/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as customRouteRouteImport } from './routes/(custom)/route';
import { Route as mainRouteRouteImport } from './routes/(main)/route';
import { Route as IdsRedirectRouteImport } from './routes/ids-redirect';
import { Route as UnauthorizedRouteImport } from './routes/unauthorized';
import { Route as customExternalRouteRouteImport } from './routes/(custom)/external/route';
import { Route as customExternalSupplierRouteImport } from './routes/(custom)/external-supplier';
import { Route as customPickupRouteImport } from './routes/(custom)/pickup';
import { Route as mainIndexRouteImport } from './routes/(main)/index';
import { Route as mainDemandRouteRouteImport } from './routes/(main)/demand/route';
import { Route as mainSettingsRouteRouteImport } from './routes/(main)/settings/route';
import { Route as mainAccountIndexRouteImport } from './routes/(main)/account/index';
import { Route as mainAgentChatIndexRouteImport } from './routes/(main)/agent-chat/index';
import { Route as mainAnalyticsIndexRouteImport } from './routes/(main)/analytics/index';
import { Route as mainLegalIndexRouteImport } from './routes/(main)/legal/index';
import { Route as mainReleaseNotesIndexRouteImport } from './routes/(main)/release-notes/index';
import { Route as mainSettingsAdminRouteRouteImport } from './routes/(main)/settings/admin/route';
import { Route as mainSettingsArticleMasterRouteRouteImport } from './routes/(main)/settings/article-master/route';
import { Route as mainSuppliersIndexRouteImport } from './routes/(main)/suppliers/index';
import { Route as mainSuppliersSupplierIdRouteRouteImport } from './routes/(main)/suppliers/$supplierId/route';
import { Route as mainSupportIndexRouteImport } from './routes/(main)/support/index';
import { Route as customExternalUnsubscribeIndexRouteImport } from './routes/(custom)/external/unsubscribe/index';
import { Route as mainAnalyticsDeliveriesIndexRouteImport } from './routes/(main)/analytics/deliveries/index';
import { Route as mainAnalyticsEsgIndexRouteImport } from './routes/(main)/analytics/esg/index';
import { Route as mainAnalyticsUsageIndexRouteImport } from './routes/(main)/analytics/usage/index';
import { Route as mainDeliveriesAllV2IndexRouteImport } from './routes/(main)/deliveries/all-v2/index';
import { Route as mainDeliveriesAllIndexRouteImport } from './routes/(main)/deliveries/all/index';
import { Route as mainDeliveriesAllDeliveryIdRouteRouteImport } from './routes/(main)/deliveries/all/$deliveryId/route';
import { Route as mainDeliveriesRecentChangesIndexRouteImport } from './routes/(main)/deliveries/recent-changes/index';
import { Route as mainDeliveriesScansIndexRouteImport } from './routes/(main)/deliveries/scans/index';
import { Route as mainDemandCallOffsIndexRouteImport } from './routes/(main)/demand/call-offs/index';
import { Route as mainDemandContractsIndexRouteImport } from './routes/(main)/demand/contracts/index';
import { Route as mainDemandContractsCreateRouteRouteImport } from './routes/(main)/demand/contracts/create/route';
import { Route as mainInvoicesInboxIndexRouteImport } from './routes/(main)/invoices/inbox/index';
import { Route as mainInvoicesIncomingIndexRouteImport } from './routes/(main)/invoices/incoming/index';
import { Route as mainInvoicesIncomingInvoiceIdRouteRouteImport } from './routes/(main)/invoices/incoming/$invoiceId/route';
import { Route as mainInvoicesOutgoingIndexRouteImport } from './routes/(main)/invoices/outgoing/index';
import { Route as mainInvoicesSettingsIndexRouteImport } from './routes/(main)/invoices/settings/index';
import { Route as mainSettingsAdminDataSyncRouteRouteImport } from './routes/(main)/settings/admin/data-sync/route';
import { Route as mainSettingsDataProtectionIndexRouteImport } from './routes/(main)/settings/data-protection/index';
import { Route as mainSettingsIgnoredArticlesIndexRouteImport } from './routes/(main)/settings/ignored-articles/index';
import { Route as mainSettingsImprintIndexRouteImport } from './routes/(main)/settings/imprint/index';
import { Route as mainSettingsInvoiceCheckIndexRouteImport } from './routes/(main)/settings/invoice-check/index';
import { Route as mainSettingsMasterdataIndexRouteImport } from './routes/(main)/settings/masterdata/index';
import { Route as mainSettingsPartnerSettingsIndexRouteImport } from './routes/(main)/settings/partner-settings/index';
import { Route as mainSettingsProductPriceIndexRouteImport } from './routes/(main)/settings/product-price/index';
import { Route as mainSuppliersSupplierIdIndexRouteImport } from './routes/(main)/suppliers/$supplierId/index';
import { Route as mainSupportFaqIndexRouteImport } from './routes/(main)/support/faq/index';
import { Route as customExternalCallOffsCallOffIdIndexRouteImport } from './routes/(custom)/external/call-offs.$callOffId/index';
import { Route as customExternalDataExchangeActivationRequestIdIndexRouteImport } from './routes/(custom)/external/data-exchange-activation.$requestId/index';
import { Route as mainDeliveriesAllDeliveryIdIndexRouteImport } from './routes/(main)/deliveries/all/$deliveryId/index';
import { Route as mainDeliveriesAllDeliveryIdDataQualityRouteImport } from './routes/(main)/deliveries/all/$deliveryId/data-quality';
import { Route as mainDeliveriesAllCreateDeliveryNoteIndexRouteImport } from './routes/(main)/deliveries/all/create-delivery-note/index';
import { Route as mainDeliveriesAllCreateServiceNoteIndexRouteImport } from './routes/(main)/deliveries/all/create-service-note/index';
import { Route as mainDeliveriesScansScanIdIndexRouteImport } from './routes/(main)/deliveries/scans/$scanId/index';
import { Route as mainDeliveriesScansImportIndexRouteImport } from './routes/(main)/deliveries/scans/import/index';
import { Route as mainDemandCallOffsCallOffIdIndexRouteImport } from './routes/(main)/demand/call-offs/$callOffId/index';
import { Route as mainDemandCallOffsCalendarIndexRouteImport } from './routes/(main)/demand/call-offs/calendar/index';
import { Route as mainDemandCallOffsCreateIndexRouteImport } from './routes/(main)/demand/call-offs/create/index';
import { Route as mainDemandContractsContractIdIndexRouteImport } from './routes/(main)/demand/contracts/$contractId/index';
import { Route as mainDemandContractsContractIdEditRouteRouteImport } from './routes/(main)/demand/contracts/$contractId/edit/route';
import { Route as mainDemandContractsCreateIndexRouteImport } from './routes/(main)/demand/contracts/create/index';
import { Route as mainInvoicesInboxEmailIdIndexRouteImport } from './routes/(main)/invoices/inbox/$emailId/index';
import { Route as mainInvoicesIncomingInvoiceIdIndexRouteImport } from './routes/(main)/invoices/incoming/$invoiceId/index';
import { Route as mainInvoicesV2IncomingIndexRouteImport } from './routes/(main)/invoices/v2/incoming/index';
import { Route as mainSettingsAdminCustomFieldsIndexRouteImport } from './routes/(main)/settings/admin/custom-fields/index';
import { Route as mainSettingsAdminDataSubscriptionLogsIndexRouteImport } from './routes/(main)/settings/admin/data-subscription-logs/index';
import { Route as mainSettingsAdminDataSubscriptionsIndexRouteImport } from './routes/(main)/settings/admin/data-subscriptions/index';
import { Route as mainSettingsAdminDataSyncIndexRouteImport } from './routes/(main)/settings/admin/data-sync/index';
import { Route as mainSettingsAdminDemoIndexRouteImport } from './routes/(main)/settings/admin/demo/index';
import { Route as mainSettingsAdminPdfSettingsIndexRouteImport } from './routes/(main)/settings/admin/pdf-settings/index';
import { Route as mainSettingsAdminSignatureFieldsIndexRouteImport } from './routes/(main)/settings/admin/signature-fields/index';
import { Route as mainSettingsArticleMasterArticlesIndexRouteImport } from './routes/(main)/settings/article-master/articles/index';
import { Route as mainSettingsArticleMasterCategoriesIndexRouteImport } from './routes/(main)/settings/article-master/categories/index';
import { Route as mainSettingsMasterdataCompaniesIndexRouteImport } from './routes/(main)/settings/masterdata/companies/index';
import { Route as mainSettingsMasterdataCostCentersIndexRouteImport } from './routes/(main)/settings/masterdata/cost-centers/index';
import { Route as mainSettingsMasterdataLedgerAccountsIndexRouteImport } from './routes/(main)/settings/masterdata/ledger-accounts/index';
import { Route as mainSettingsMasterdataOrgGroupsIndexRouteImport } from './routes/(main)/settings/masterdata/org-groups/index';
import { Route as mainSettingsMasterdataRolesIndexRouteImport } from './routes/(main)/settings/masterdata/roles/index';
import { Route as mainSettingsMasterdataSitesIndexRouteImport } from './routes/(main)/settings/masterdata/sites/index';
import { Route as mainSettingsMasterdataTaxCodesIndexRouteImport } from './routes/(main)/settings/masterdata/tax-codes/index';
import { Route as mainSettingsMasterdataUserGroupsIndexRouteImport } from './routes/(main)/settings/masterdata/user-groups/index';
import { Route as mainSettingsMasterdataUsersIndexRouteImport } from './routes/(main)/settings/masterdata/users/index';
import { Route as mainSettingsMasterdataVehiclesIndexRouteImport } from './routes/(main)/settings/masterdata/vehicles/index';
import { Route as mainSettingsPartnerSettingsImportIndexRouteImport } from './routes/(main)/settings/partner-settings/import/index';
import { Route as mainSuppliersSupplierIdEditIndexRouteImport } from './routes/(main)/suppliers/$supplierId/edit/index';
import { Route as mainDemandCallOffsCallOffIdEditIndexRouteImport } from './routes/(main)/demand/call-offs/$callOffId/edit/index';
import { Route as mainDemandContractsContractIdEditIndexRouteImport } from './routes/(main)/demand/contracts/$contractId/edit/index';
import { Route as mainInvoicesV2IncomingInvoiceIdIndexRouteImport } from './routes/(main)/invoices/v2/incoming/$invoiceId/index';
import { Route as mainInvoicesV2IncomingImportIndexRouteImport } from './routes/(main)/invoices/v2/incoming/import/index';
import { Route as mainSettingsAdminDataSubscriptionLogsLogIdIndexRouteImport } from './routes/(main)/settings/admin/data-subscription-logs/$logId/index';
import { Route as mainSettingsAdminDataSyncLogsIndexRouteImport } from './routes/(main)/settings/admin/data-sync/logs/index';
import { Route as mainDemandContractsContractIdItemsItemIdIndexRouteImport } from './routes/(main)/demand/contracts/$contractId/items/$itemId/index';
import { Route as mainDemandContractsCreateItemsItemIdIndexRouteImport } from './routes/(main)/demand/contracts/create/items/$itemId/index';
import { Route as mainSettingsAdminDataSyncJobIdTaskIdIndexRouteImport } from './routes/(main)/settings/admin/data-sync/$jobId.$taskId_/index';
import { Route as mainSettingsAdminDataSyncLogsLogIdIndexRouteImport } from './routes/(main)/settings/admin/data-sync/logs/$logId/index';
import { Route as mainDemandContractsContractIdEditItemsItemIdIndexRouteImport } from './routes/(main)/demand/contracts/$contractId/edit/items/$itemId/index';

const customRouteRoute = customRouteRouteImport.update({
  id: '/(custom)',
  getParentRoute: () => rootRouteImport,
} as any);
const mainRouteRoute = mainRouteRouteImport.update({
  id: '/(main)',
  getParentRoute: () => rootRouteImport,
} as any);
const IdsRedirectRoute = IdsRedirectRouteImport.update({
  id: '/ids-redirect',
  path: '/ids-redirect',
  getParentRoute: () => rootRouteImport,
} as any);
const UnauthorizedRoute = UnauthorizedRouteImport.update({
  id: '/unauthorized',
  path: '/unauthorized',
  getParentRoute: () => rootRouteImport,
} as any);
const customExternalRouteRoute = customExternalRouteRouteImport.update({
  id: '/external',
  path: '/external',
  getParentRoute: () => customRouteRoute,
} as any);
const customExternalSupplierRoute = customExternalSupplierRouteImport.update({
  id: '/external-supplier',
  path: '/external-supplier',
  getParentRoute: () => customRouteRoute,
} as any);
const customPickupRoute = customPickupRouteImport.update({
  id: '/pickup',
  path: '/pickup',
  getParentRoute: () => customRouteRoute,
} as any);
const mainIndexRoute = mainIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => mainRouteRoute,
} as any);
const mainDemandRouteRoute = mainDemandRouteRouteImport.update({
  id: '/demand',
  path: '/demand',
  getParentRoute: () => mainRouteRoute,
} as any);
const mainSettingsRouteRoute = mainSettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => mainRouteRoute,
} as any);
const mainAccountIndexRoute = mainAccountIndexRouteImport.update({
  id: '/account/',
  path: '/account/',
  getParentRoute: () => mainRouteRoute,
} as any);
const mainAgentChatIndexRoute = mainAgentChatIndexRouteImport.update({
  id: '/agent-chat/',
  path: '/agent-chat/',
  getParentRoute: () => mainRouteRoute,
} as any);
const mainAnalyticsIndexRoute = mainAnalyticsIndexRouteImport.update({
  id: '/analytics/',
  path: '/analytics/',
  getParentRoute: () => mainRouteRoute,
} as any);
const mainLegalIndexRoute = mainLegalIndexRouteImport.update({
  id: '/legal/',
  path: '/legal/',
  getParentRoute: () => mainRouteRoute,
} as any);
const mainReleaseNotesIndexRoute = mainReleaseNotesIndexRouteImport.update({
  id: '/release-notes/',
  path: '/release-notes/',
  getParentRoute: () => mainRouteRoute,
} as any);
const mainSettingsAdminRouteRoute = mainSettingsAdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => mainSettingsRouteRoute,
} as any);
const mainSettingsArticleMasterRouteRoute =
  mainSettingsArticleMasterRouteRouteImport.update({
    id: '/article-master',
    path: '/article-master',
    getParentRoute: () => mainSettingsRouteRoute,
  } as any);
const mainSuppliersIndexRoute = mainSuppliersIndexRouteImport.update({
  id: '/suppliers/',
  path: '/suppliers/',
  getParentRoute: () => mainRouteRoute,
} as any);
const mainSuppliersSupplierIdRouteRoute =
  mainSuppliersSupplierIdRouteRouteImport.update({
    id: '/suppliers/$supplierId',
    path: '/suppliers/$supplierId',
    getParentRoute: () => mainRouteRoute,
  } as any);
const mainSupportIndexRoute = mainSupportIndexRouteImport.update({
  id: '/support/',
  path: '/support/',
  getParentRoute: () => mainRouteRoute,
} as any);
const customExternalUnsubscribeIndexRoute =
  customExternalUnsubscribeIndexRouteImport.update({
    id: '/unsubscribe/',
    path: '/unsubscribe/',
    getParentRoute: () => customExternalRouteRoute,
  } as any);
const mainAnalyticsDeliveriesIndexRoute =
  mainAnalyticsDeliveriesIndexRouteImport.update({
    id: '/analytics/deliveries/',
    path: '/analytics/deliveries/',
    getParentRoute: () => mainRouteRoute,
  } as any);
const mainAnalyticsEsgIndexRoute = mainAnalyticsEsgIndexRouteImport.update({
  id: '/analytics/esg/',
  path: '/analytics/esg/',
  getParentRoute: () => mainRouteRoute,
} as any);
const mainAnalyticsUsageIndexRoute = mainAnalyticsUsageIndexRouteImport.update({
  id: '/analytics/usage/',
  path: '/analytics/usage/',
  getParentRoute: () => mainRouteRoute,
} as any);
const mainDeliveriesAllV2IndexRoute =
  mainDeliveriesAllV2IndexRouteImport.update({
    id: '/deliveries/all-v2/',
    path: '/deliveries/all-v2/',
    getParentRoute: () => mainRouteRoute,
  } as any);
const mainDeliveriesAllIndexRoute = mainDeliveriesAllIndexRouteImport.update({
  id: '/deliveries/all/',
  path: '/deliveries/all/',
  getParentRoute: () => mainRouteRoute,
} as any);
const mainDeliveriesAllDeliveryIdRouteRoute =
  mainDeliveriesAllDeliveryIdRouteRouteImport.update({
    id: '/deliveries/all/$deliveryId',
    path: '/deliveries/all/$deliveryId',
    getParentRoute: () => mainRouteRoute,
  } as any);
const mainDeliveriesRecentChangesIndexRoute =
  mainDeliveriesRecentChangesIndexRouteImport.update({
    id: '/deliveries/recent-changes/',
    path: '/deliveries/recent-changes/',
    getParentRoute: () => mainRouteRoute,
  } as any);
const mainDeliveriesScansIndexRoute =
  mainDeliveriesScansIndexRouteImport.update({
    id: '/deliveries/scans/',
    path: '/deliveries/scans/',
    getParentRoute: () => mainRouteRoute,
  } as any);
const mainDemandCallOffsIndexRoute = mainDemandCallOffsIndexRouteImport.update({
  id: '/call-offs/',
  path: '/call-offs/',
  getParentRoute: () => mainDemandRouteRoute,
} as any);
const mainDemandContractsIndexRoute =
  mainDemandContractsIndexRouteImport.update({
    id: '/contracts/',
    path: '/contracts/',
    getParentRoute: () => mainDemandRouteRoute,
  } as any);
const mainDemandContractsCreateRouteRoute =
  mainDemandContractsCreateRouteRouteImport.update({
    id: '/contracts/create',
    path: '/contracts/create',
    getParentRoute: () => mainDemandRouteRoute,
  } as any);
const mainInvoicesInboxIndexRoute = mainInvoicesInboxIndexRouteImport.update({
  id: '/invoices/inbox/',
  path: '/invoices/inbox/',
  getParentRoute: () => mainRouteRoute,
} as any);
const mainInvoicesIncomingIndexRoute =
  mainInvoicesIncomingIndexRouteImport.update({
    id: '/invoices/incoming/',
    path: '/invoices/incoming/',
    getParentRoute: () => mainRouteRoute,
  } as any);
const mainInvoicesIncomingInvoiceIdRouteRoute =
  mainInvoicesIncomingInvoiceIdRouteRouteImport.update({
    id: '/invoices/incoming/$invoiceId',
    path: '/invoices/incoming/$invoiceId',
    getParentRoute: () => mainRouteRoute,
  } as any);
const mainInvoicesOutgoingIndexRoute =
  mainInvoicesOutgoingIndexRouteImport.update({
    id: '/invoices/outgoing/',
    path: '/invoices/outgoing/',
    getParentRoute: () => mainRouteRoute,
  } as any);
const mainInvoicesSettingsIndexRoute =
  mainInvoicesSettingsIndexRouteImport.update({
    id: '/invoices/settings/',
    path: '/invoices/settings/',
    getParentRoute: () => mainRouteRoute,
  } as any);
const mainSettingsAdminDataSyncRouteRoute =
  mainSettingsAdminDataSyncRouteRouteImport.update({
    id: '/data-sync',
    path: '/data-sync',
    getParentRoute: () => mainSettingsAdminRouteRoute,
  } as any);
const mainSettingsDataProtectionIndexRoute =
  mainSettingsDataProtectionIndexRouteImport.update({
    id: '/data-protection/',
    path: '/data-protection/',
    getParentRoute: () => mainSettingsRouteRoute,
  } as any);
const mainSettingsIgnoredArticlesIndexRoute =
  mainSettingsIgnoredArticlesIndexRouteImport.update({
    id: '/ignored-articles/',
    path: '/ignored-articles/',
    getParentRoute: () => mainSettingsRouteRoute,
  } as any);
const mainSettingsImprintIndexRoute =
  mainSettingsImprintIndexRouteImport.update({
    id: '/imprint/',
    path: '/imprint/',
    getParentRoute: () => mainSettingsRouteRoute,
  } as any);
const mainSettingsInvoiceCheckIndexRoute =
  mainSettingsInvoiceCheckIndexRouteImport.update({
    id: '/invoice-check/',
    path: '/invoice-check/',
    getParentRoute: () => mainSettingsRouteRoute,
  } as any);
const mainSettingsMasterdataIndexRoute =
  mainSettingsMasterdataIndexRouteImport.update({
    id: '/masterdata/',
    path: '/masterdata/',
    getParentRoute: () => mainSettingsRouteRoute,
  } as any);
const mainSettingsPartnerSettingsIndexRoute =
  mainSettingsPartnerSettingsIndexRouteImport.update({
    id: '/partner-settings/',
    path: '/partner-settings/',
    getParentRoute: () => mainSettingsRouteRoute,
  } as any);
const mainSettingsProductPriceIndexRoute =
  mainSettingsProductPriceIndexRouteImport.update({
    id: '/product-price/',
    path: '/product-price/',
    getParentRoute: () => mainSettingsRouteRoute,
  } as any);
const mainSuppliersSupplierIdIndexRoute =
  mainSuppliersSupplierIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => mainSuppliersSupplierIdRouteRoute,
  } as any);
const mainSupportFaqIndexRoute = mainSupportFaqIndexRouteImport.update({
  id: '/support/faq/',
  path: '/support/faq/',
  getParentRoute: () => mainRouteRoute,
} as any);
const customExternalCallOffsCallOffIdIndexRoute =
  customExternalCallOffsCallOffIdIndexRouteImport.update({
    id: '/call-offs/$callOffId/',
    path: '/call-offs/$callOffId/',
    getParentRoute: () => customExternalRouteRoute,
  } as any);
const customExternalDataExchangeActivationRequestIdIndexRoute =
  customExternalDataExchangeActivationRequestIdIndexRouteImport.update({
    id: '/data-exchange-activation/$requestId/',
    path: '/data-exchange-activation/$requestId/',
    getParentRoute: () => customExternalRouteRoute,
  } as any);
const mainDeliveriesAllDeliveryIdIndexRoute =
  mainDeliveriesAllDeliveryIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => mainDeliveriesAllDeliveryIdRouteRoute,
  } as any);
const mainDeliveriesAllDeliveryIdDataQualityRoute =
  mainDeliveriesAllDeliveryIdDataQualityRouteImport.update({
    id: '/data-quality',
    path: '/data-quality',
    getParentRoute: () => mainDeliveriesAllDeliveryIdRouteRoute,
  } as any);
const mainDeliveriesAllCreateDeliveryNoteIndexRoute =
  mainDeliveriesAllCreateDeliveryNoteIndexRouteImport.update({
    id: '/deliveries/all/create-delivery-note/',
    path: '/deliveries/all/create-delivery-note/',
    getParentRoute: () => mainRouteRoute,
  } as any);
const mainDeliveriesAllCreateServiceNoteIndexRoute =
  mainDeliveriesAllCreateServiceNoteIndexRouteImport.update({
    id: '/deliveries/all/create-service-note/',
    path: '/deliveries/all/create-service-note/',
    getParentRoute: () => mainRouteRoute,
  } as any);
const mainDeliveriesScansScanIdIndexRoute =
  mainDeliveriesScansScanIdIndexRouteImport.update({
    id: '/deliveries/scans/$scanId/',
    path: '/deliveries/scans/$scanId/',
    getParentRoute: () => mainRouteRoute,
  } as any);
const mainDeliveriesScansImportIndexRoute =
  mainDeliveriesScansImportIndexRouteImport.update({
    id: '/deliveries/scans/import/',
    path: '/deliveries/scans/import/',
    getParentRoute: () => mainRouteRoute,
  } as any);
const mainDemandCallOffsCallOffIdIndexRoute =
  mainDemandCallOffsCallOffIdIndexRouteImport.update({
    id: '/call-offs/$callOffId/',
    path: '/call-offs/$callOffId/',
    getParentRoute: () => mainDemandRouteRoute,
  } as any);
const mainDemandCallOffsCalendarIndexRoute =
  mainDemandCallOffsCalendarIndexRouteImport.update({
    id: '/call-offs/calendar/',
    path: '/call-offs/calendar/',
    getParentRoute: () => mainDemandRouteRoute,
  } as any);
const mainDemandCallOffsCreateIndexRoute =
  mainDemandCallOffsCreateIndexRouteImport.update({
    id: '/call-offs/create/',
    path: '/call-offs/create/',
    getParentRoute: () => mainDemandRouteRoute,
  } as any);
const mainDemandContractsContractIdIndexRoute =
  mainDemandContractsContractIdIndexRouteImport.update({
    id: '/contracts/$contractId/',
    path: '/contracts/$contractId/',
    getParentRoute: () => mainDemandRouteRoute,
  } as any);
const mainDemandContractsContractIdEditRouteRoute =
  mainDemandContractsContractIdEditRouteRouteImport.update({
    id: '/contracts/$contractId/edit',
    path: '/contracts/$contractId/edit',
    getParentRoute: () => mainDemandRouteRoute,
  } as any);
const mainDemandContractsCreateIndexRoute =
  mainDemandContractsCreateIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => mainDemandContractsCreateRouteRoute,
  } as any);
const mainInvoicesInboxEmailIdIndexRoute =
  mainInvoicesInboxEmailIdIndexRouteImport.update({
    id: '/invoices/inbox/$emailId/',
    path: '/invoices/inbox/$emailId/',
    getParentRoute: () => mainRouteRoute,
  } as any);
const mainInvoicesIncomingInvoiceIdIndexRoute =
  mainInvoicesIncomingInvoiceIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => mainInvoicesIncomingInvoiceIdRouteRoute,
  } as any);
const mainInvoicesV2IncomingIndexRoute =
  mainInvoicesV2IncomingIndexRouteImport.update({
    id: '/invoices/v2/incoming/',
    path: '/invoices/v2/incoming/',
    getParentRoute: () => mainRouteRoute,
  } as any);
const mainSettingsAdminCustomFieldsIndexRoute =
  mainSettingsAdminCustomFieldsIndexRouteImport.update({
    id: '/custom-fields/',
    path: '/custom-fields/',
    getParentRoute: () => mainSettingsAdminRouteRoute,
  } as any);
const mainSettingsAdminDataSubscriptionLogsIndexRoute =
  mainSettingsAdminDataSubscriptionLogsIndexRouteImport.update({
    id: '/data-subscription-logs/',
    path: '/data-subscription-logs/',
    getParentRoute: () => mainSettingsAdminRouteRoute,
  } as any);
const mainSettingsAdminDataSubscriptionsIndexRoute =
  mainSettingsAdminDataSubscriptionsIndexRouteImport.update({
    id: '/data-subscriptions/',
    path: '/data-subscriptions/',
    getParentRoute: () => mainSettingsAdminRouteRoute,
  } as any);
const mainSettingsAdminDataSyncIndexRoute =
  mainSettingsAdminDataSyncIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => mainSettingsAdminDataSyncRouteRoute,
  } as any);
const mainSettingsAdminDemoIndexRoute =
  mainSettingsAdminDemoIndexRouteImport.update({
    id: '/demo/',
    path: '/demo/',
    getParentRoute: () => mainSettingsAdminRouteRoute,
  } as any);
const mainSettingsAdminPdfSettingsIndexRoute =
  mainSettingsAdminPdfSettingsIndexRouteImport.update({
    id: '/pdf-settings/',
    path: '/pdf-settings/',
    getParentRoute: () => mainSettingsAdminRouteRoute,
  } as any);
const mainSettingsAdminSignatureFieldsIndexRoute =
  mainSettingsAdminSignatureFieldsIndexRouteImport.update({
    id: '/signature-fields/',
    path: '/signature-fields/',
    getParentRoute: () => mainSettingsAdminRouteRoute,
  } as any);
const mainSettingsArticleMasterArticlesIndexRoute =
  mainSettingsArticleMasterArticlesIndexRouteImport.update({
    id: '/articles/',
    path: '/articles/',
    getParentRoute: () => mainSettingsArticleMasterRouteRoute,
  } as any);
const mainSettingsArticleMasterCategoriesIndexRoute =
  mainSettingsArticleMasterCategoriesIndexRouteImport.update({
    id: '/categories/',
    path: '/categories/',
    getParentRoute: () => mainSettingsArticleMasterRouteRoute,
  } as any);
const mainSettingsMasterdataCompaniesIndexRoute =
  mainSettingsMasterdataCompaniesIndexRouteImport.update({
    id: '/masterdata/companies/',
    path: '/masterdata/companies/',
    getParentRoute: () => mainSettingsRouteRoute,
  } as any);
const mainSettingsMasterdataCostCentersIndexRoute =
  mainSettingsMasterdataCostCentersIndexRouteImport.update({
    id: '/masterdata/cost-centers/',
    path: '/masterdata/cost-centers/',
    getParentRoute: () => mainSettingsRouteRoute,
  } as any);
const mainSettingsMasterdataLedgerAccountsIndexRoute =
  mainSettingsMasterdataLedgerAccountsIndexRouteImport.update({
    id: '/masterdata/ledger-accounts/',
    path: '/masterdata/ledger-accounts/',
    getParentRoute: () => mainSettingsRouteRoute,
  } as any);
const mainSettingsMasterdataOrgGroupsIndexRoute =
  mainSettingsMasterdataOrgGroupsIndexRouteImport.update({
    id: '/masterdata/org-groups/',
    path: '/masterdata/org-groups/',
    getParentRoute: () => mainSettingsRouteRoute,
  } as any);
const mainSettingsMasterdataRolesIndexRoute =
  mainSettingsMasterdataRolesIndexRouteImport.update({
    id: '/masterdata/roles/',
    path: '/masterdata/roles/',
    getParentRoute: () => mainSettingsRouteRoute,
  } as any);
const mainSettingsMasterdataSitesIndexRoute =
  mainSettingsMasterdataSitesIndexRouteImport.update({
    id: '/masterdata/sites/',
    path: '/masterdata/sites/',
    getParentRoute: () => mainSettingsRouteRoute,
  } as any);
const mainSettingsMasterdataTaxCodesIndexRoute =
  mainSettingsMasterdataTaxCodesIndexRouteImport.update({
    id: '/masterdata/tax-codes/',
    path: '/masterdata/tax-codes/',
    getParentRoute: () => mainSettingsRouteRoute,
  } as any);
const mainSettingsMasterdataUserGroupsIndexRoute =
  mainSettingsMasterdataUserGroupsIndexRouteImport.update({
    id: '/masterdata/user-groups/',
    path: '/masterdata/user-groups/',
    getParentRoute: () => mainSettingsRouteRoute,
  } as any);
const mainSettingsMasterdataUsersIndexRoute =
  mainSettingsMasterdataUsersIndexRouteImport.update({
    id: '/masterdata/users/',
    path: '/masterdata/users/',
    getParentRoute: () => mainSettingsRouteRoute,
  } as any);
const mainSettingsMasterdataVehiclesIndexRoute =
  mainSettingsMasterdataVehiclesIndexRouteImport.update({
    id: '/masterdata/vehicles/',
    path: '/masterdata/vehicles/',
    getParentRoute: () => mainSettingsRouteRoute,
  } as any);
const mainSettingsPartnerSettingsImportIndexRoute =
  mainSettingsPartnerSettingsImportIndexRouteImport.update({
    id: '/partner-settings/import/',
    path: '/partner-settings/import/',
    getParentRoute: () => mainSettingsRouteRoute,
  } as any);
const mainSuppliersSupplierIdEditIndexRoute =
  mainSuppliersSupplierIdEditIndexRouteImport.update({
    id: '/edit/',
    path: '/edit/',
    getParentRoute: () => mainSuppliersSupplierIdRouteRoute,
  } as any);
const mainDemandCallOffsCallOffIdEditIndexRoute =
  mainDemandCallOffsCallOffIdEditIndexRouteImport.update({
    id: '/call-offs/$callOffId/edit/',
    path: '/call-offs/$callOffId/edit/',
    getParentRoute: () => mainDemandRouteRoute,
  } as any);
const mainDemandContractsContractIdEditIndexRoute =
  mainDemandContractsContractIdEditIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => mainDemandContractsContractIdEditRouteRoute,
  } as any);
const mainInvoicesV2IncomingInvoiceIdIndexRoute =
  mainInvoicesV2IncomingInvoiceIdIndexRouteImport.update({
    id: '/invoices/v2/incoming/$invoiceId/',
    path: '/invoices/v2/incoming/$invoiceId/',
    getParentRoute: () => mainRouteRoute,
  } as any);
const mainInvoicesV2IncomingImportIndexRoute =
  mainInvoicesV2IncomingImportIndexRouteImport.update({
    id: '/invoices/v2/incoming/import/',
    path: '/invoices/v2/incoming/import/',
    getParentRoute: () => mainRouteRoute,
  } as any);
const mainSettingsAdminDataSubscriptionLogsLogIdIndexRoute =
  mainSettingsAdminDataSubscriptionLogsLogIdIndexRouteImport.update({
    id: '/data-subscription-logs/$logId/',
    path: '/data-subscription-logs/$logId/',
    getParentRoute: () => mainSettingsAdminRouteRoute,
  } as any);
const mainSettingsAdminDataSyncLogsIndexRoute =
  mainSettingsAdminDataSyncLogsIndexRouteImport.update({
    id: '/logs/',
    path: '/logs/',
    getParentRoute: () => mainSettingsAdminDataSyncRouteRoute,
  } as any);
const mainDemandContractsContractIdItemsItemIdIndexRoute =
  mainDemandContractsContractIdItemsItemIdIndexRouteImport.update({
    id: '/contracts/$contractId/items/$itemId/',
    path: '/contracts/$contractId/items/$itemId/',
    getParentRoute: () => mainDemandRouteRoute,
  } as any);
const mainDemandContractsCreateItemsItemIdIndexRoute =
  mainDemandContractsCreateItemsItemIdIndexRouteImport.update({
    id: '/items/$itemId/',
    path: '/items/$itemId/',
    getParentRoute: () => mainDemandContractsCreateRouteRoute,
  } as any);
const mainSettingsAdminDataSyncJobIdTaskIdIndexRoute =
  mainSettingsAdminDataSyncJobIdTaskIdIndexRouteImport.update({
    id: '/$jobId/$taskId_/',
    path: '/$jobId/$taskId/',
    getParentRoute: () => mainSettingsAdminDataSyncRouteRoute,
  } as any);
const mainSettingsAdminDataSyncLogsLogIdIndexRoute =
  mainSettingsAdminDataSyncLogsLogIdIndexRouteImport.update({
    id: '/logs/$logId/',
    path: '/logs/$logId/',
    getParentRoute: () => mainSettingsAdminDataSyncRouteRoute,
  } as any);
const mainDemandContractsContractIdEditItemsItemIdIndexRoute =
  mainDemandContractsContractIdEditItemsItemIdIndexRouteImport.update({
    id: '/items/$itemId/',
    path: '/items/$itemId/',
    getParentRoute: () => mainDemandContractsContractIdEditRouteRoute,
  } as any);

export interface FileRoutesByFullPath {
  '/ids-redirect': typeof IdsRedirectRoute;
  '/unauthorized': typeof UnauthorizedRoute;
  '/external': typeof customExternalRouteRouteWithChildren;
  '/demand': typeof mainDemandRouteRouteWithChildren;
  '/settings': typeof mainSettingsRouteRouteWithChildren;
  '/external-supplier': typeof customExternalSupplierRoute;
  '/pickup': typeof customPickupRoute;
  '/': typeof mainIndexRoute;
  '/settings/admin': typeof mainSettingsAdminRouteRouteWithChildren;
  '/settings/article-master': typeof mainSettingsArticleMasterRouteRouteWithChildren;
  '/suppliers/$supplierId': typeof mainSuppliersSupplierIdRouteRouteWithChildren;
  '/account/': typeof mainAccountIndexRoute;
  '/agent-chat/': typeof mainAgentChatIndexRoute;
  '/analytics/': typeof mainAnalyticsIndexRoute;
  '/legal/': typeof mainLegalIndexRoute;
  '/release-notes/': typeof mainReleaseNotesIndexRoute;
  '/suppliers/': typeof mainSuppliersIndexRoute;
  '/support/': typeof mainSupportIndexRoute;
  '/deliveries/all/$deliveryId': typeof mainDeliveriesAllDeliveryIdRouteRouteWithChildren;
  '/demand/contracts/create': typeof mainDemandContractsCreateRouteRouteWithChildren;
  '/invoices/incoming/$invoiceId': typeof mainInvoicesIncomingInvoiceIdRouteRouteWithChildren;
  '/settings/admin/data-sync': typeof mainSettingsAdminDataSyncRouteRouteWithChildren;
  '/external/unsubscribe/': typeof customExternalUnsubscribeIndexRoute;
  '/analytics/deliveries/': typeof mainAnalyticsDeliveriesIndexRoute;
  '/analytics/esg/': typeof mainAnalyticsEsgIndexRoute;
  '/analytics/usage/': typeof mainAnalyticsUsageIndexRoute;
  '/deliveries/all-v2/': typeof mainDeliveriesAllV2IndexRoute;
  '/deliveries/all/': typeof mainDeliveriesAllIndexRoute;
  '/deliveries/recent-changes/': typeof mainDeliveriesRecentChangesIndexRoute;
  '/deliveries/scans/': typeof mainDeliveriesScansIndexRoute;
  '/demand/call-offs/': typeof mainDemandCallOffsIndexRoute;
  '/demand/contracts/': typeof mainDemandContractsIndexRoute;
  '/invoices/inbox/': typeof mainInvoicesInboxIndexRoute;
  '/invoices/incoming/': typeof mainInvoicesIncomingIndexRoute;
  '/invoices/outgoing/': typeof mainInvoicesOutgoingIndexRoute;
  '/invoices/settings/': typeof mainInvoicesSettingsIndexRoute;
  '/settings/data-protection/': typeof mainSettingsDataProtectionIndexRoute;
  '/settings/ignored-articles/': typeof mainSettingsIgnoredArticlesIndexRoute;
  '/settings/imprint/': typeof mainSettingsImprintIndexRoute;
  '/settings/invoice-check/': typeof mainSettingsInvoiceCheckIndexRoute;
  '/settings/masterdata/': typeof mainSettingsMasterdataIndexRoute;
  '/settings/partner-settings/': typeof mainSettingsPartnerSettingsIndexRoute;
  '/settings/product-price/': typeof mainSettingsProductPriceIndexRoute;
  '/suppliers/$supplierId/': typeof mainSuppliersSupplierIdIndexRoute;
  '/support/faq/': typeof mainSupportFaqIndexRoute;
  '/demand/contracts/$contractId/edit': typeof mainDemandContractsContractIdEditRouteRouteWithChildren;
  '/deliveries/all/$deliveryId/data-quality': typeof mainDeliveriesAllDeliveryIdDataQualityRoute;
  '/external/call-offs/$callOffId/': typeof customExternalCallOffsCallOffIdIndexRoute;
  '/external/data-exchange-activation/$requestId/': typeof customExternalDataExchangeActivationRequestIdIndexRoute;
  '/deliveries/all/$deliveryId/': typeof mainDeliveriesAllDeliveryIdIndexRoute;
  '/deliveries/all/create-delivery-note/': typeof mainDeliveriesAllCreateDeliveryNoteIndexRoute;
  '/deliveries/all/create-service-note/': typeof mainDeliveriesAllCreateServiceNoteIndexRoute;
  '/deliveries/scans/$scanId/': typeof mainDeliveriesScansScanIdIndexRoute;
  '/deliveries/scans/import/': typeof mainDeliveriesScansImportIndexRoute;
  '/demand/call-offs/$callOffId/': typeof mainDemandCallOffsCallOffIdIndexRoute;
  '/demand/call-offs/calendar/': typeof mainDemandCallOffsCalendarIndexRoute;
  '/demand/call-offs/create/': typeof mainDemandCallOffsCreateIndexRoute;
  '/demand/contracts/$contractId/': typeof mainDemandContractsContractIdIndexRoute;
  '/demand/contracts/create/': typeof mainDemandContractsCreateIndexRoute;
  '/invoices/inbox/$emailId/': typeof mainInvoicesInboxEmailIdIndexRoute;
  '/invoices/incoming/$invoiceId/': typeof mainInvoicesIncomingInvoiceIdIndexRoute;
  '/invoices/v2/incoming/': typeof mainInvoicesV2IncomingIndexRoute;
  '/settings/admin/custom-fields/': typeof mainSettingsAdminCustomFieldsIndexRoute;
  '/settings/admin/data-subscription-logs/': typeof mainSettingsAdminDataSubscriptionLogsIndexRoute;
  '/settings/admin/data-subscriptions/': typeof mainSettingsAdminDataSubscriptionsIndexRoute;
  '/settings/admin/data-sync/': typeof mainSettingsAdminDataSyncIndexRoute;
  '/settings/admin/demo/': typeof mainSettingsAdminDemoIndexRoute;
  '/settings/admin/pdf-settings/': typeof mainSettingsAdminPdfSettingsIndexRoute;
  '/settings/admin/signature-fields/': typeof mainSettingsAdminSignatureFieldsIndexRoute;
  '/settings/article-master/articles/': typeof mainSettingsArticleMasterArticlesIndexRoute;
  '/settings/article-master/categories/': typeof mainSettingsArticleMasterCategoriesIndexRoute;
  '/settings/masterdata/companies/': typeof mainSettingsMasterdataCompaniesIndexRoute;
  '/settings/masterdata/cost-centers/': typeof mainSettingsMasterdataCostCentersIndexRoute;
  '/settings/masterdata/ledger-accounts/': typeof mainSettingsMasterdataLedgerAccountsIndexRoute;
  '/settings/masterdata/org-groups/': typeof mainSettingsMasterdataOrgGroupsIndexRoute;
  '/settings/masterdata/roles/': typeof mainSettingsMasterdataRolesIndexRoute;
  '/settings/masterdata/sites/': typeof mainSettingsMasterdataSitesIndexRoute;
  '/settings/masterdata/tax-codes/': typeof mainSettingsMasterdataTaxCodesIndexRoute;
  '/settings/masterdata/user-groups/': typeof mainSettingsMasterdataUserGroupsIndexRoute;
  '/settings/masterdata/users/': typeof mainSettingsMasterdataUsersIndexRoute;
  '/settings/masterdata/vehicles/': typeof mainSettingsMasterdataVehiclesIndexRoute;
  '/settings/partner-settings/import/': typeof mainSettingsPartnerSettingsImportIndexRoute;
  '/suppliers/$supplierId/edit/': typeof mainSuppliersSupplierIdEditIndexRoute;
  '/demand/call-offs/$callOffId/edit/': typeof mainDemandCallOffsCallOffIdEditIndexRoute;
  '/demand/contracts/$contractId/edit/': typeof mainDemandContractsContractIdEditIndexRoute;
  '/invoices/v2/incoming/$invoiceId/': typeof mainInvoicesV2IncomingInvoiceIdIndexRoute;
  '/invoices/v2/incoming/import/': typeof mainInvoicesV2IncomingImportIndexRoute;
  '/settings/admin/data-subscription-logs/$logId/': typeof mainSettingsAdminDataSubscriptionLogsLogIdIndexRoute;
  '/settings/admin/data-sync/logs/': typeof mainSettingsAdminDataSyncLogsIndexRoute;
  '/demand/contracts/$contractId/items/$itemId/': typeof mainDemandContractsContractIdItemsItemIdIndexRoute;
  '/demand/contracts/create/items/$itemId/': typeof mainDemandContractsCreateItemsItemIdIndexRoute;
  '/settings/admin/data-sync/$jobId/$taskId/': typeof mainSettingsAdminDataSyncJobIdTaskIdIndexRoute;
  '/settings/admin/data-sync/logs/$logId/': typeof mainSettingsAdminDataSyncLogsLogIdIndexRoute;
  '/demand/contracts/$contractId/edit/items/$itemId/': typeof mainDemandContractsContractIdEditItemsItemIdIndexRoute;
}
export interface FileRoutesByTo {
  '/ids-redirect': typeof IdsRedirectRoute;
  '/unauthorized': typeof UnauthorizedRoute;
  '/external': typeof customExternalRouteRouteWithChildren;
  '/demand': typeof mainDemandRouteRouteWithChildren;
  '/settings': typeof mainSettingsRouteRouteWithChildren;
  '/external-supplier': typeof customExternalSupplierRoute;
  '/pickup': typeof customPickupRoute;
  '/': typeof mainIndexRoute;
  '/settings/admin': typeof mainSettingsAdminRouteRouteWithChildren;
  '/settings/article-master': typeof mainSettingsArticleMasterRouteRouteWithChildren;
  '/account': typeof mainAccountIndexRoute;
  '/agent-chat': typeof mainAgentChatIndexRoute;
  '/analytics': typeof mainAnalyticsIndexRoute;
  '/legal': typeof mainLegalIndexRoute;
  '/release-notes': typeof mainReleaseNotesIndexRoute;
  '/suppliers': typeof mainSuppliersIndexRoute;
  '/support': typeof mainSupportIndexRoute;
  '/external/unsubscribe': typeof customExternalUnsubscribeIndexRoute;
  '/analytics/deliveries': typeof mainAnalyticsDeliveriesIndexRoute;
  '/analytics/esg': typeof mainAnalyticsEsgIndexRoute;
  '/analytics/usage': typeof mainAnalyticsUsageIndexRoute;
  '/deliveries/all-v2': typeof mainDeliveriesAllV2IndexRoute;
  '/deliveries/all': typeof mainDeliveriesAllIndexRoute;
  '/deliveries/recent-changes': typeof mainDeliveriesRecentChangesIndexRoute;
  '/deliveries/scans': typeof mainDeliveriesScansIndexRoute;
  '/demand/call-offs': typeof mainDemandCallOffsIndexRoute;
  '/demand/contracts': typeof mainDemandContractsIndexRoute;
  '/invoices/inbox': typeof mainInvoicesInboxIndexRoute;
  '/invoices/incoming': typeof mainInvoicesIncomingIndexRoute;
  '/invoices/outgoing': typeof mainInvoicesOutgoingIndexRoute;
  '/invoices/settings': typeof mainInvoicesSettingsIndexRoute;
  '/settings/data-protection': typeof mainSettingsDataProtectionIndexRoute;
  '/settings/ignored-articles': typeof mainSettingsIgnoredArticlesIndexRoute;
  '/settings/imprint': typeof mainSettingsImprintIndexRoute;
  '/settings/invoice-check': typeof mainSettingsInvoiceCheckIndexRoute;
  '/settings/masterdata': typeof mainSettingsMasterdataIndexRoute;
  '/settings/partner-settings': typeof mainSettingsPartnerSettingsIndexRoute;
  '/settings/product-price': typeof mainSettingsProductPriceIndexRoute;
  '/suppliers/$supplierId': typeof mainSuppliersSupplierIdIndexRoute;
  '/support/faq': typeof mainSupportFaqIndexRoute;
  '/deliveries/all/$deliveryId/data-quality': typeof mainDeliveriesAllDeliveryIdDataQualityRoute;
  '/external/call-offs/$callOffId': typeof customExternalCallOffsCallOffIdIndexRoute;
  '/external/data-exchange-activation/$requestId': typeof customExternalDataExchangeActivationRequestIdIndexRoute;
  '/deliveries/all/$deliveryId': typeof mainDeliveriesAllDeliveryIdIndexRoute;
  '/deliveries/all/create-delivery-note': typeof mainDeliveriesAllCreateDeliveryNoteIndexRoute;
  '/deliveries/all/create-service-note': typeof mainDeliveriesAllCreateServiceNoteIndexRoute;
  '/deliveries/scans/$scanId': typeof mainDeliveriesScansScanIdIndexRoute;
  '/deliveries/scans/import': typeof mainDeliveriesScansImportIndexRoute;
  '/demand/call-offs/$callOffId': typeof mainDemandCallOffsCallOffIdIndexRoute;
  '/demand/call-offs/calendar': typeof mainDemandCallOffsCalendarIndexRoute;
  '/demand/call-offs/create': typeof mainDemandCallOffsCreateIndexRoute;
  '/demand/contracts/$contractId': typeof mainDemandContractsContractIdIndexRoute;
  '/demand/contracts/create': typeof mainDemandContractsCreateIndexRoute;
  '/invoices/inbox/$emailId': typeof mainInvoicesInboxEmailIdIndexRoute;
  '/invoices/incoming/$invoiceId': typeof mainInvoicesIncomingInvoiceIdIndexRoute;
  '/invoices/v2/incoming': typeof mainInvoicesV2IncomingIndexRoute;
  '/settings/admin/custom-fields': typeof mainSettingsAdminCustomFieldsIndexRoute;
  '/settings/admin/data-subscription-logs': typeof mainSettingsAdminDataSubscriptionLogsIndexRoute;
  '/settings/admin/data-subscriptions': typeof mainSettingsAdminDataSubscriptionsIndexRoute;
  '/settings/admin/data-sync': typeof mainSettingsAdminDataSyncIndexRoute;
  '/settings/admin/demo': typeof mainSettingsAdminDemoIndexRoute;
  '/settings/admin/pdf-settings': typeof mainSettingsAdminPdfSettingsIndexRoute;
  '/settings/admin/signature-fields': typeof mainSettingsAdminSignatureFieldsIndexRoute;
  '/settings/article-master/articles': typeof mainSettingsArticleMasterArticlesIndexRoute;
  '/settings/article-master/categories': typeof mainSettingsArticleMasterCategoriesIndexRoute;
  '/settings/masterdata/companies': typeof mainSettingsMasterdataCompaniesIndexRoute;
  '/settings/masterdata/cost-centers': typeof mainSettingsMasterdataCostCentersIndexRoute;
  '/settings/masterdata/ledger-accounts': typeof mainSettingsMasterdataLedgerAccountsIndexRoute;
  '/settings/masterdata/org-groups': typeof mainSettingsMasterdataOrgGroupsIndexRoute;
  '/settings/masterdata/roles': typeof mainSettingsMasterdataRolesIndexRoute;
  '/settings/masterdata/sites': typeof mainSettingsMasterdataSitesIndexRoute;
  '/settings/masterdata/tax-codes': typeof mainSettingsMasterdataTaxCodesIndexRoute;
  '/settings/masterdata/user-groups': typeof mainSettingsMasterdataUserGroupsIndexRoute;
  '/settings/masterdata/users': typeof mainSettingsMasterdataUsersIndexRoute;
  '/settings/masterdata/vehicles': typeof mainSettingsMasterdataVehiclesIndexRoute;
  '/settings/partner-settings/import': typeof mainSettingsPartnerSettingsImportIndexRoute;
  '/suppliers/$supplierId/edit': typeof mainSuppliersSupplierIdEditIndexRoute;
  '/demand/call-offs/$callOffId/edit': typeof mainDemandCallOffsCallOffIdEditIndexRoute;
  '/demand/contracts/$contractId/edit': typeof mainDemandContractsContractIdEditIndexRoute;
  '/invoices/v2/incoming/$invoiceId': typeof mainInvoicesV2IncomingInvoiceIdIndexRoute;
  '/invoices/v2/incoming/import': typeof mainInvoicesV2IncomingImportIndexRoute;
  '/settings/admin/data-subscription-logs/$logId': typeof mainSettingsAdminDataSubscriptionLogsLogIdIndexRoute;
  '/settings/admin/data-sync/logs': typeof mainSettingsAdminDataSyncLogsIndexRoute;
  '/demand/contracts/$contractId/items/$itemId': typeof mainDemandContractsContractIdItemsItemIdIndexRoute;
  '/demand/contracts/create/items/$itemId': typeof mainDemandContractsCreateItemsItemIdIndexRoute;
  '/settings/admin/data-sync/$jobId/$taskId': typeof mainSettingsAdminDataSyncJobIdTaskIdIndexRoute;
  '/settings/admin/data-sync/logs/$logId': typeof mainSettingsAdminDataSyncLogsLogIdIndexRoute;
  '/demand/contracts/$contractId/edit/items/$itemId': typeof mainDemandContractsContractIdEditItemsItemIdIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/(custom)': typeof customRouteRouteWithChildren;
  '/(main)': typeof mainRouteRouteWithChildren;
  '/ids-redirect': typeof IdsRedirectRoute;
  '/unauthorized': typeof UnauthorizedRoute;
  '/(custom)/external': typeof customExternalRouteRouteWithChildren;
  '/(main)/demand': typeof mainDemandRouteRouteWithChildren;
  '/(main)/settings': typeof mainSettingsRouteRouteWithChildren;
  '/(custom)/external-supplier': typeof customExternalSupplierRoute;
  '/(custom)/pickup': typeof customPickupRoute;
  '/(main)/': typeof mainIndexRoute;
  '/(main)/settings/admin': typeof mainSettingsAdminRouteRouteWithChildren;
  '/(main)/settings/article-master': typeof mainSettingsArticleMasterRouteRouteWithChildren;
  '/(main)/suppliers/$supplierId': typeof mainSuppliersSupplierIdRouteRouteWithChildren;
  '/(main)/account/': typeof mainAccountIndexRoute;
  '/(main)/agent-chat/': typeof mainAgentChatIndexRoute;
  '/(main)/analytics/': typeof mainAnalyticsIndexRoute;
  '/(main)/legal/': typeof mainLegalIndexRoute;
  '/(main)/release-notes/': typeof mainReleaseNotesIndexRoute;
  '/(main)/suppliers/': typeof mainSuppliersIndexRoute;
  '/(main)/support/': typeof mainSupportIndexRoute;
  '/(main)/deliveries/all/$deliveryId': typeof mainDeliveriesAllDeliveryIdRouteRouteWithChildren;
  '/(main)/demand/contracts/create': typeof mainDemandContractsCreateRouteRouteWithChildren;
  '/(main)/invoices/incoming/$invoiceId': typeof mainInvoicesIncomingInvoiceIdRouteRouteWithChildren;
  '/(main)/settings/admin/data-sync': typeof mainSettingsAdminDataSyncRouteRouteWithChildren;
  '/(custom)/external/unsubscribe/': typeof customExternalUnsubscribeIndexRoute;
  '/(main)/analytics/deliveries/': typeof mainAnalyticsDeliveriesIndexRoute;
  '/(main)/analytics/esg/': typeof mainAnalyticsEsgIndexRoute;
  '/(main)/analytics/usage/': typeof mainAnalyticsUsageIndexRoute;
  '/(main)/deliveries/all-v2/': typeof mainDeliveriesAllV2IndexRoute;
  '/(main)/deliveries/all/': typeof mainDeliveriesAllIndexRoute;
  '/(main)/deliveries/recent-changes/': typeof mainDeliveriesRecentChangesIndexRoute;
  '/(main)/deliveries/scans/': typeof mainDeliveriesScansIndexRoute;
  '/(main)/demand/call-offs/': typeof mainDemandCallOffsIndexRoute;
  '/(main)/demand/contracts/': typeof mainDemandContractsIndexRoute;
  '/(main)/invoices/inbox/': typeof mainInvoicesInboxIndexRoute;
  '/(main)/invoices/incoming/': typeof mainInvoicesIncomingIndexRoute;
  '/(main)/invoices/outgoing/': typeof mainInvoicesOutgoingIndexRoute;
  '/(main)/invoices/settings/': typeof mainInvoicesSettingsIndexRoute;
  '/(main)/settings/data-protection/': typeof mainSettingsDataProtectionIndexRoute;
  '/(main)/settings/ignored-articles/': typeof mainSettingsIgnoredArticlesIndexRoute;
  '/(main)/settings/imprint/': typeof mainSettingsImprintIndexRoute;
  '/(main)/settings/invoice-check/': typeof mainSettingsInvoiceCheckIndexRoute;
  '/(main)/settings/masterdata/': typeof mainSettingsMasterdataIndexRoute;
  '/(main)/settings/partner-settings/': typeof mainSettingsPartnerSettingsIndexRoute;
  '/(main)/settings/product-price/': typeof mainSettingsProductPriceIndexRoute;
  '/(main)/suppliers/$supplierId/': typeof mainSuppliersSupplierIdIndexRoute;
  '/(main)/support/faq/': typeof mainSupportFaqIndexRoute;
  '/(main)/demand/contracts/$contractId/edit': typeof mainDemandContractsContractIdEditRouteRouteWithChildren;
  '/(main)/deliveries/all/$deliveryId/data-quality': typeof mainDeliveriesAllDeliveryIdDataQualityRoute;
  '/(custom)/external/call-offs/$callOffId/': typeof customExternalCallOffsCallOffIdIndexRoute;
  '/(custom)/external/data-exchange-activation/$requestId/': typeof customExternalDataExchangeActivationRequestIdIndexRoute;
  '/(main)/deliveries/all/$deliveryId/': typeof mainDeliveriesAllDeliveryIdIndexRoute;
  '/(main)/deliveries/all/create-delivery-note/': typeof mainDeliveriesAllCreateDeliveryNoteIndexRoute;
  '/(main)/deliveries/all/create-service-note/': typeof mainDeliveriesAllCreateServiceNoteIndexRoute;
  '/(main)/deliveries/scans/$scanId/': typeof mainDeliveriesScansScanIdIndexRoute;
  '/(main)/deliveries/scans/import/': typeof mainDeliveriesScansImportIndexRoute;
  '/(main)/demand/call-offs/$callOffId/': typeof mainDemandCallOffsCallOffIdIndexRoute;
  '/(main)/demand/call-offs/calendar/': typeof mainDemandCallOffsCalendarIndexRoute;
  '/(main)/demand/call-offs/create/': typeof mainDemandCallOffsCreateIndexRoute;
  '/(main)/demand/contracts/$contractId/': typeof mainDemandContractsContractIdIndexRoute;
  '/(main)/demand/contracts/create/': typeof mainDemandContractsCreateIndexRoute;
  '/(main)/invoices/inbox/$emailId/': typeof mainInvoicesInboxEmailIdIndexRoute;
  '/(main)/invoices/incoming/$invoiceId/': typeof mainInvoicesIncomingInvoiceIdIndexRoute;
  '/(main)/invoices/v2/incoming/': typeof mainInvoicesV2IncomingIndexRoute;
  '/(main)/settings/admin/custom-fields/': typeof mainSettingsAdminCustomFieldsIndexRoute;
  '/(main)/settings/admin/data-subscription-logs/': typeof mainSettingsAdminDataSubscriptionLogsIndexRoute;
  '/(main)/settings/admin/data-subscriptions/': typeof mainSettingsAdminDataSubscriptionsIndexRoute;
  '/(main)/settings/admin/data-sync/': typeof mainSettingsAdminDataSyncIndexRoute;
  '/(main)/settings/admin/demo/': typeof mainSettingsAdminDemoIndexRoute;
  '/(main)/settings/admin/pdf-settings/': typeof mainSettingsAdminPdfSettingsIndexRoute;
  '/(main)/settings/admin/signature-fields/': typeof mainSettingsAdminSignatureFieldsIndexRoute;
  '/(main)/settings/article-master/articles/': typeof mainSettingsArticleMasterArticlesIndexRoute;
  '/(main)/settings/article-master/categories/': typeof mainSettingsArticleMasterCategoriesIndexRoute;
  '/(main)/settings/masterdata/companies/': typeof mainSettingsMasterdataCompaniesIndexRoute;
  '/(main)/settings/masterdata/cost-centers/': typeof mainSettingsMasterdataCostCentersIndexRoute;
  '/(main)/settings/masterdata/ledger-accounts/': typeof mainSettingsMasterdataLedgerAccountsIndexRoute;
  '/(main)/settings/masterdata/org-groups/': typeof mainSettingsMasterdataOrgGroupsIndexRoute;
  '/(main)/settings/masterdata/roles/': typeof mainSettingsMasterdataRolesIndexRoute;
  '/(main)/settings/masterdata/sites/': typeof mainSettingsMasterdataSitesIndexRoute;
  '/(main)/settings/masterdata/tax-codes/': typeof mainSettingsMasterdataTaxCodesIndexRoute;
  '/(main)/settings/masterdata/user-groups/': typeof mainSettingsMasterdataUserGroupsIndexRoute;
  '/(main)/settings/masterdata/users/': typeof mainSettingsMasterdataUsersIndexRoute;
  '/(main)/settings/masterdata/vehicles/': typeof mainSettingsMasterdataVehiclesIndexRoute;
  '/(main)/settings/partner-settings/import/': typeof mainSettingsPartnerSettingsImportIndexRoute;
  '/(main)/suppliers/$supplierId/edit/': typeof mainSuppliersSupplierIdEditIndexRoute;
  '/(main)/demand/call-offs/$callOffId/edit/': typeof mainDemandCallOffsCallOffIdEditIndexRoute;
  '/(main)/demand/contracts/$contractId/edit/': typeof mainDemandContractsContractIdEditIndexRoute;
  '/(main)/invoices/v2/incoming/$invoiceId/': typeof mainInvoicesV2IncomingInvoiceIdIndexRoute;
  '/(main)/invoices/v2/incoming/import/': typeof mainInvoicesV2IncomingImportIndexRoute;
  '/(main)/settings/admin/data-subscription-logs/$logId/': typeof mainSettingsAdminDataSubscriptionLogsLogIdIndexRoute;
  '/(main)/settings/admin/data-sync/logs/': typeof mainSettingsAdminDataSyncLogsIndexRoute;
  '/(main)/demand/contracts/$contractId/items/$itemId/': typeof mainDemandContractsContractIdItemsItemIdIndexRoute;
  '/(main)/demand/contracts/create/items/$itemId/': typeof mainDemandContractsCreateItemsItemIdIndexRoute;
  '/(main)/settings/admin/data-sync/$jobId/$taskId_/': typeof mainSettingsAdminDataSyncJobIdTaskIdIndexRoute;
  '/(main)/settings/admin/data-sync/logs/$logId/': typeof mainSettingsAdminDataSyncLogsLogIdIndexRoute;
  '/(main)/demand/contracts/$contractId/edit/items/$itemId/': typeof mainDemandContractsContractIdEditItemsItemIdIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/ids-redirect'
    | '/unauthorized'
    | '/external'
    | '/demand'
    | '/settings'
    | '/external-supplier'
    | '/pickup'
    | '/'
    | '/settings/admin'
    | '/settings/article-master'
    | '/suppliers/$supplierId'
    | '/account/'
    | '/agent-chat/'
    | '/analytics/'
    | '/legal/'
    | '/release-notes/'
    | '/suppliers/'
    | '/support/'
    | '/deliveries/all/$deliveryId'
    | '/demand/contracts/create'
    | '/invoices/incoming/$invoiceId'
    | '/settings/admin/data-sync'
    | '/external/unsubscribe/'
    | '/analytics/deliveries/'
    | '/analytics/esg/'
    | '/analytics/usage/'
    | '/deliveries/all-v2/'
    | '/deliveries/all/'
    | '/deliveries/recent-changes/'
    | '/deliveries/scans/'
    | '/demand/call-offs/'
    | '/demand/contracts/'
    | '/invoices/inbox/'
    | '/invoices/incoming/'
    | '/invoices/outgoing/'
    | '/invoices/settings/'
    | '/settings/data-protection/'
    | '/settings/ignored-articles/'
    | '/settings/imprint/'
    | '/settings/invoice-check/'
    | '/settings/masterdata/'
    | '/settings/partner-settings/'
    | '/settings/product-price/'
    | '/suppliers/$supplierId/'
    | '/support/faq/'
    | '/demand/contracts/$contractId/edit'
    | '/deliveries/all/$deliveryId/data-quality'
    | '/external/call-offs/$callOffId/'
    | '/external/data-exchange-activation/$requestId/'
    | '/deliveries/all/$deliveryId/'
    | '/deliveries/all/create-delivery-note/'
    | '/deliveries/all/create-service-note/'
    | '/deliveries/scans/$scanId/'
    | '/deliveries/scans/import/'
    | '/demand/call-offs/$callOffId/'
    | '/demand/call-offs/calendar/'
    | '/demand/call-offs/create/'
    | '/demand/contracts/$contractId/'
    | '/demand/contracts/create/'
    | '/invoices/inbox/$emailId/'
    | '/invoices/incoming/$invoiceId/'
    | '/invoices/v2/incoming/'
    | '/settings/admin/custom-fields/'
    | '/settings/admin/data-subscription-logs/'
    | '/settings/admin/data-subscriptions/'
    | '/settings/admin/data-sync/'
    | '/settings/admin/demo/'
    | '/settings/admin/pdf-settings/'
    | '/settings/admin/signature-fields/'
    | '/settings/article-master/articles/'
    | '/settings/article-master/categories/'
    | '/settings/masterdata/companies/'
    | '/settings/masterdata/cost-centers/'
    | '/settings/masterdata/ledger-accounts/'
    | '/settings/masterdata/org-groups/'
    | '/settings/masterdata/roles/'
    | '/settings/masterdata/sites/'
    | '/settings/masterdata/tax-codes/'
    | '/settings/masterdata/user-groups/'
    | '/settings/masterdata/users/'
    | '/settings/masterdata/vehicles/'
    | '/settings/partner-settings/import/'
    | '/suppliers/$supplierId/edit/'
    | '/demand/call-offs/$callOffId/edit/'
    | '/demand/contracts/$contractId/edit/'
    | '/invoices/v2/incoming/$invoiceId/'
    | '/invoices/v2/incoming/import/'
    | '/settings/admin/data-subscription-logs/$logId/'
    | '/settings/admin/data-sync/logs/'
    | '/demand/contracts/$contractId/items/$itemId/'
    | '/demand/contracts/create/items/$itemId/'
    | '/settings/admin/data-sync/$jobId/$taskId/'
    | '/settings/admin/data-sync/logs/$logId/'
    | '/demand/contracts/$contractId/edit/items/$itemId/';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/ids-redirect'
    | '/unauthorized'
    | '/external'
    | '/demand'
    | '/settings'
    | '/external-supplier'
    | '/pickup'
    | '/'
    | '/settings/admin'
    | '/settings/article-master'
    | '/account'
    | '/agent-chat'
    | '/analytics'
    | '/legal'
    | '/release-notes'
    | '/suppliers'
    | '/support'
    | '/external/unsubscribe'
    | '/analytics/deliveries'
    | '/analytics/esg'
    | '/analytics/usage'
    | '/deliveries/all-v2'
    | '/deliveries/all'
    | '/deliveries/recent-changes'
    | '/deliveries/scans'
    | '/demand/call-offs'
    | '/demand/contracts'
    | '/invoices/inbox'
    | '/invoices/incoming'
    | '/invoices/outgoing'
    | '/invoices/settings'
    | '/settings/data-protection'
    | '/settings/ignored-articles'
    | '/settings/imprint'
    | '/settings/invoice-check'
    | '/settings/masterdata'
    | '/settings/partner-settings'
    | '/settings/product-price'
    | '/suppliers/$supplierId'
    | '/support/faq'
    | '/deliveries/all/$deliveryId/data-quality'
    | '/external/call-offs/$callOffId'
    | '/external/data-exchange-activation/$requestId'
    | '/deliveries/all/$deliveryId'
    | '/deliveries/all/create-delivery-note'
    | '/deliveries/all/create-service-note'
    | '/deliveries/scans/$scanId'
    | '/deliveries/scans/import'
    | '/demand/call-offs/$callOffId'
    | '/demand/call-offs/calendar'
    | '/demand/call-offs/create'
    | '/demand/contracts/$contractId'
    | '/demand/contracts/create'
    | '/invoices/inbox/$emailId'
    | '/invoices/incoming/$invoiceId'
    | '/invoices/v2/incoming'
    | '/settings/admin/custom-fields'
    | '/settings/admin/data-subscription-logs'
    | '/settings/admin/data-subscriptions'
    | '/settings/admin/data-sync'
    | '/settings/admin/demo'
    | '/settings/admin/pdf-settings'
    | '/settings/admin/signature-fields'
    | '/settings/article-master/articles'
    | '/settings/article-master/categories'
    | '/settings/masterdata/companies'
    | '/settings/masterdata/cost-centers'
    | '/settings/masterdata/ledger-accounts'
    | '/settings/masterdata/org-groups'
    | '/settings/masterdata/roles'
    | '/settings/masterdata/sites'
    | '/settings/masterdata/tax-codes'
    | '/settings/masterdata/user-groups'
    | '/settings/masterdata/users'
    | '/settings/masterdata/vehicles'
    | '/settings/partner-settings/import'
    | '/suppliers/$supplierId/edit'
    | '/demand/call-offs/$callOffId/edit'
    | '/demand/contracts/$contractId/edit'
    | '/invoices/v2/incoming/$invoiceId'
    | '/invoices/v2/incoming/import'
    | '/settings/admin/data-subscription-logs/$logId'
    | '/settings/admin/data-sync/logs'
    | '/demand/contracts/$contractId/items/$itemId'
    | '/demand/contracts/create/items/$itemId'
    | '/settings/admin/data-sync/$jobId/$taskId'
    | '/settings/admin/data-sync/logs/$logId'
    | '/demand/contracts/$contractId/edit/items/$itemId';
  id:
    | '__root__'
    | '/(custom)'
    | '/(main)'
    | '/ids-redirect'
    | '/unauthorized'
    | '/(custom)/external'
    | '/(main)/demand'
    | '/(main)/settings'
    | '/(custom)/external-supplier'
    | '/(custom)/pickup'
    | '/(main)/'
    | '/(main)/settings/admin'
    | '/(main)/settings/article-master'
    | '/(main)/suppliers/$supplierId'
    | '/(main)/account/'
    | '/(main)/agent-chat/'
    | '/(main)/analytics/'
    | '/(main)/legal/'
    | '/(main)/release-notes/'
    | '/(main)/suppliers/'
    | '/(main)/support/'
    | '/(main)/deliveries/all/$deliveryId'
    | '/(main)/demand/contracts/create'
    | '/(main)/invoices/incoming/$invoiceId'
    | '/(main)/settings/admin/data-sync'
    | '/(custom)/external/unsubscribe/'
    | '/(main)/analytics/deliveries/'
    | '/(main)/analytics/esg/'
    | '/(main)/analytics/usage/'
    | '/(main)/deliveries/all-v2/'
    | '/(main)/deliveries/all/'
    | '/(main)/deliveries/recent-changes/'
    | '/(main)/deliveries/scans/'
    | '/(main)/demand/call-offs/'
    | '/(main)/demand/contracts/'
    | '/(main)/invoices/inbox/'
    | '/(main)/invoices/incoming/'
    | '/(main)/invoices/outgoing/'
    | '/(main)/invoices/settings/'
    | '/(main)/settings/data-protection/'
    | '/(main)/settings/ignored-articles/'
    | '/(main)/settings/imprint/'
    | '/(main)/settings/invoice-check/'
    | '/(main)/settings/masterdata/'
    | '/(main)/settings/partner-settings/'
    | '/(main)/settings/product-price/'
    | '/(main)/suppliers/$supplierId/'
    | '/(main)/support/faq/'
    | '/(main)/demand/contracts/$contractId/edit'
    | '/(main)/deliveries/all/$deliveryId/data-quality'
    | '/(custom)/external/call-offs/$callOffId/'
    | '/(custom)/external/data-exchange-activation/$requestId/'
    | '/(main)/deliveries/all/$deliveryId/'
    | '/(main)/deliveries/all/create-delivery-note/'
    | '/(main)/deliveries/all/create-service-note/'
    | '/(main)/deliveries/scans/$scanId/'
    | '/(main)/deliveries/scans/import/'
    | '/(main)/demand/call-offs/$callOffId/'
    | '/(main)/demand/call-offs/calendar/'
    | '/(main)/demand/call-offs/create/'
    | '/(main)/demand/contracts/$contractId/'
    | '/(main)/demand/contracts/create/'
    | '/(main)/invoices/inbox/$emailId/'
    | '/(main)/invoices/incoming/$invoiceId/'
    | '/(main)/invoices/v2/incoming/'
    | '/(main)/settings/admin/custom-fields/'
    | '/(main)/settings/admin/data-subscription-logs/'
    | '/(main)/settings/admin/data-subscriptions/'
    | '/(main)/settings/admin/data-sync/'
    | '/(main)/settings/admin/demo/'
    | '/(main)/settings/admin/pdf-settings/'
    | '/(main)/settings/admin/signature-fields/'
    | '/(main)/settings/article-master/articles/'
    | '/(main)/settings/article-master/categories/'
    | '/(main)/settings/masterdata/companies/'
    | '/(main)/settings/masterdata/cost-centers/'
    | '/(main)/settings/masterdata/ledger-accounts/'
    | '/(main)/settings/masterdata/org-groups/'
    | '/(main)/settings/masterdata/roles/'
    | '/(main)/settings/masterdata/sites/'
    | '/(main)/settings/masterdata/tax-codes/'
    | '/(main)/settings/masterdata/user-groups/'
    | '/(main)/settings/masterdata/users/'
    | '/(main)/settings/masterdata/vehicles/'
    | '/(main)/settings/partner-settings/import/'
    | '/(main)/suppliers/$supplierId/edit/'
    | '/(main)/demand/call-offs/$callOffId/edit/'
    | '/(main)/demand/contracts/$contractId/edit/'
    | '/(main)/invoices/v2/incoming/$invoiceId/'
    | '/(main)/invoices/v2/incoming/import/'
    | '/(main)/settings/admin/data-subscription-logs/$logId/'
    | '/(main)/settings/admin/data-sync/logs/'
    | '/(main)/demand/contracts/$contractId/items/$itemId/'
    | '/(main)/demand/contracts/create/items/$itemId/'
    | '/(main)/settings/admin/data-sync/$jobId/$taskId_/'
    | '/(main)/settings/admin/data-sync/logs/$logId/'
    | '/(main)/demand/contracts/$contractId/edit/items/$itemId/';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  customRouteRoute: typeof customRouteRouteWithChildren;
  mainRouteRoute: typeof mainRouteRouteWithChildren;
  IdsRedirectRoute: typeof IdsRedirectRoute;
  UnauthorizedRoute: typeof UnauthorizedRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/(custom)': {
      id: '/(custom)';
      path: '';
      fullPath: '';
      preLoaderRoute: typeof customRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(main)': {
      id: '/(main)';
      path: '';
      fullPath: '';
      preLoaderRoute: typeof mainRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/ids-redirect': {
      id: '/ids-redirect';
      path: '/ids-redirect';
      fullPath: '/ids-redirect';
      preLoaderRoute: typeof IdsRedirectRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/unauthorized': {
      id: '/unauthorized';
      path: '/unauthorized';
      fullPath: '/unauthorized';
      preLoaderRoute: typeof UnauthorizedRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/(custom)/external': {
      id: '/(custom)/external';
      path: '/external';
      fullPath: '/external';
      preLoaderRoute: typeof customExternalRouteRouteImport;
      parentRoute: typeof customRouteRoute;
    };
    '/(custom)/external-supplier': {
      id: '/(custom)/external-supplier';
      path: '/external-supplier';
      fullPath: '/external-supplier';
      preLoaderRoute: typeof customExternalSupplierRouteImport;
      parentRoute: typeof customRouteRoute;
    };
    '/(custom)/pickup': {
      id: '/(custom)/pickup';
      path: '/pickup';
      fullPath: '/pickup';
      preLoaderRoute: typeof customPickupRouteImport;
      parentRoute: typeof customRouteRoute;
    };
    '/(main)/': {
      id: '/(main)/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof mainIndexRouteImport;
      parentRoute: typeof mainRouteRoute;
    };
    '/(main)/demand': {
      id: '/(main)/demand';
      path: '/demand';
      fullPath: '/demand';
      preLoaderRoute: typeof mainDemandRouteRouteImport;
      parentRoute: typeof mainRouteRoute;
    };
    '/(main)/settings': {
      id: '/(main)/settings';
      path: '/settings';
      fullPath: '/settings';
      preLoaderRoute: typeof mainSettingsRouteRouteImport;
      parentRoute: typeof mainRouteRoute;
    };
    '/(main)/account/': {
      id: '/(main)/account/';
      path: '/account';
      fullPath: '/account/';
      preLoaderRoute: typeof mainAccountIndexRouteImport;
      parentRoute: typeof mainRouteRoute;
    };
    '/(main)/agent-chat/': {
      id: '/(main)/agent-chat/';
      path: '/agent-chat';
      fullPath: '/agent-chat/';
      preLoaderRoute: typeof mainAgentChatIndexRouteImport;
      parentRoute: typeof mainRouteRoute;
    };
    '/(main)/analytics/': {
      id: '/(main)/analytics/';
      path: '/analytics';
      fullPath: '/analytics/';
      preLoaderRoute: typeof mainAnalyticsIndexRouteImport;
      parentRoute: typeof mainRouteRoute;
    };
    '/(main)/legal/': {
      id: '/(main)/legal/';
      path: '/legal';
      fullPath: '/legal/';
      preLoaderRoute: typeof mainLegalIndexRouteImport;
      parentRoute: typeof mainRouteRoute;
    };
    '/(main)/release-notes/': {
      id: '/(main)/release-notes/';
      path: '/release-notes';
      fullPath: '/release-notes/';
      preLoaderRoute: typeof mainReleaseNotesIndexRouteImport;
      parentRoute: typeof mainRouteRoute;
    };
    '/(main)/settings/admin': {
      id: '/(main)/settings/admin';
      path: '/admin';
      fullPath: '/settings/admin';
      preLoaderRoute: typeof mainSettingsAdminRouteRouteImport;
      parentRoute: typeof mainSettingsRouteRoute;
    };
    '/(main)/settings/article-master': {
      id: '/(main)/settings/article-master';
      path: '/article-master';
      fullPath: '/settings/article-master';
      preLoaderRoute: typeof mainSettingsArticleMasterRouteRouteImport;
      parentRoute: typeof mainSettingsRouteRoute;
    };
    '/(main)/suppliers/': {
      id: '/(main)/suppliers/';
      path: '/suppliers';
      fullPath: '/suppliers/';
      preLoaderRoute: typeof mainSuppliersIndexRouteImport;
      parentRoute: typeof mainRouteRoute;
    };
    '/(main)/suppliers/$supplierId': {
      id: '/(main)/suppliers/$supplierId';
      path: '/suppliers/$supplierId';
      fullPath: '/suppliers/$supplierId';
      preLoaderRoute: typeof mainSuppliersSupplierIdRouteRouteImport;
      parentRoute: typeof mainRouteRoute;
    };
    '/(main)/support/': {
      id: '/(main)/support/';
      path: '/support';
      fullPath: '/support/';
      preLoaderRoute: typeof mainSupportIndexRouteImport;
      parentRoute: typeof mainRouteRoute;
    };
    '/(custom)/external/unsubscribe/': {
      id: '/(custom)/external/unsubscribe/';
      path: '/unsubscribe';
      fullPath: '/external/unsubscribe/';
      preLoaderRoute: typeof customExternalUnsubscribeIndexRouteImport;
      parentRoute: typeof customExternalRouteRoute;
    };
    '/(main)/analytics/deliveries/': {
      id: '/(main)/analytics/deliveries/';
      path: '/analytics/deliveries';
      fullPath: '/analytics/deliveries/';
      preLoaderRoute: typeof mainAnalyticsDeliveriesIndexRouteImport;
      parentRoute: typeof mainRouteRoute;
    };
    '/(main)/analytics/esg/': {
      id: '/(main)/analytics/esg/';
      path: '/analytics/esg';
      fullPath: '/analytics/esg/';
      preLoaderRoute: typeof mainAnalyticsEsgIndexRouteImport;
      parentRoute: typeof mainRouteRoute;
    };
    '/(main)/analytics/usage/': {
      id: '/(main)/analytics/usage/';
      path: '/analytics/usage';
      fullPath: '/analytics/usage/';
      preLoaderRoute: typeof mainAnalyticsUsageIndexRouteImport;
      parentRoute: typeof mainRouteRoute;
    };
    '/(main)/deliveries/all-v2/': {
      id: '/(main)/deliveries/all-v2/';
      path: '/deliveries/all-v2';
      fullPath: '/deliveries/all-v2/';
      preLoaderRoute: typeof mainDeliveriesAllV2IndexRouteImport;
      parentRoute: typeof mainRouteRoute;
    };
    '/(main)/deliveries/all/': {
      id: '/(main)/deliveries/all/';
      path: '/deliveries/all';
      fullPath: '/deliveries/all/';
      preLoaderRoute: typeof mainDeliveriesAllIndexRouteImport;
      parentRoute: typeof mainRouteRoute;
    };
    '/(main)/deliveries/all/$deliveryId': {
      id: '/(main)/deliveries/all/$deliveryId';
      path: '/deliveries/all/$deliveryId';
      fullPath: '/deliveries/all/$deliveryId';
      preLoaderRoute: typeof mainDeliveriesAllDeliveryIdRouteRouteImport;
      parentRoute: typeof mainRouteRoute;
    };
    '/(main)/deliveries/recent-changes/': {
      id: '/(main)/deliveries/recent-changes/';
      path: '/deliveries/recent-changes';
      fullPath: '/deliveries/recent-changes/';
      preLoaderRoute: typeof mainDeliveriesRecentChangesIndexRouteImport;
      parentRoute: typeof mainRouteRoute;
    };
    '/(main)/deliveries/scans/': {
      id: '/(main)/deliveries/scans/';
      path: '/deliveries/scans';
      fullPath: '/deliveries/scans/';
      preLoaderRoute: typeof mainDeliveriesScansIndexRouteImport;
      parentRoute: typeof mainRouteRoute;
    };
    '/(main)/demand/call-offs/': {
      id: '/(main)/demand/call-offs/';
      path: '/call-offs';
      fullPath: '/demand/call-offs/';
      preLoaderRoute: typeof mainDemandCallOffsIndexRouteImport;
      parentRoute: typeof mainDemandRouteRoute;
    };
    '/(main)/demand/contracts/': {
      id: '/(main)/demand/contracts/';
      path: '/contracts';
      fullPath: '/demand/contracts/';
      preLoaderRoute: typeof mainDemandContractsIndexRouteImport;
      parentRoute: typeof mainDemandRouteRoute;
    };
    '/(main)/demand/contracts/create': {
      id: '/(main)/demand/contracts/create';
      path: '/contracts/create';
      fullPath: '/demand/contracts/create';
      preLoaderRoute: typeof mainDemandContractsCreateRouteRouteImport;
      parentRoute: typeof mainDemandRouteRoute;
    };
    '/(main)/invoices/inbox/': {
      id: '/(main)/invoices/inbox/';
      path: '/invoices/inbox';
      fullPath: '/invoices/inbox/';
      preLoaderRoute: typeof mainInvoicesInboxIndexRouteImport;
      parentRoute: typeof mainRouteRoute;
    };
    '/(main)/invoices/incoming/': {
      id: '/(main)/invoices/incoming/';
      path: '/invoices/incoming';
      fullPath: '/invoices/incoming/';
      preLoaderRoute: typeof mainInvoicesIncomingIndexRouteImport;
      parentRoute: typeof mainRouteRoute;
    };
    '/(main)/invoices/incoming/$invoiceId': {
      id: '/(main)/invoices/incoming/$invoiceId';
      path: '/invoices/incoming/$invoiceId';
      fullPath: '/invoices/incoming/$invoiceId';
      preLoaderRoute: typeof mainInvoicesIncomingInvoiceIdRouteRouteImport;
      parentRoute: typeof mainRouteRoute;
    };
    '/(main)/invoices/outgoing/': {
      id: '/(main)/invoices/outgoing/';
      path: '/invoices/outgoing';
      fullPath: '/invoices/outgoing/';
      preLoaderRoute: typeof mainInvoicesOutgoingIndexRouteImport;
      parentRoute: typeof mainRouteRoute;
    };
    '/(main)/invoices/settings/': {
      id: '/(main)/invoices/settings/';
      path: '/invoices/settings';
      fullPath: '/invoices/settings/';
      preLoaderRoute: typeof mainInvoicesSettingsIndexRouteImport;
      parentRoute: typeof mainRouteRoute;
    };
    '/(main)/settings/admin/data-sync': {
      id: '/(main)/settings/admin/data-sync';
      path: '/data-sync';
      fullPath: '/settings/admin/data-sync';
      preLoaderRoute: typeof mainSettingsAdminDataSyncRouteRouteImport;
      parentRoute: typeof mainSettingsAdminRouteRoute;
    };
    '/(main)/settings/data-protection/': {
      id: '/(main)/settings/data-protection/';
      path: '/data-protection';
      fullPath: '/settings/data-protection/';
      preLoaderRoute: typeof mainSettingsDataProtectionIndexRouteImport;
      parentRoute: typeof mainSettingsRouteRoute;
    };
    '/(main)/settings/ignored-articles/': {
      id: '/(main)/settings/ignored-articles/';
      path: '/ignored-articles';
      fullPath: '/settings/ignored-articles/';
      preLoaderRoute: typeof mainSettingsIgnoredArticlesIndexRouteImport;
      parentRoute: typeof mainSettingsRouteRoute;
    };
    '/(main)/settings/imprint/': {
      id: '/(main)/settings/imprint/';
      path: '/imprint';
      fullPath: '/settings/imprint/';
      preLoaderRoute: typeof mainSettingsImprintIndexRouteImport;
      parentRoute: typeof mainSettingsRouteRoute;
    };
    '/(main)/settings/invoice-check/': {
      id: '/(main)/settings/invoice-check/';
      path: '/invoice-check';
      fullPath: '/settings/invoice-check/';
      preLoaderRoute: typeof mainSettingsInvoiceCheckIndexRouteImport;
      parentRoute: typeof mainSettingsRouteRoute;
    };
    '/(main)/settings/masterdata/': {
      id: '/(main)/settings/masterdata/';
      path: '/masterdata';
      fullPath: '/settings/masterdata/';
      preLoaderRoute: typeof mainSettingsMasterdataIndexRouteImport;
      parentRoute: typeof mainSettingsRouteRoute;
    };
    '/(main)/settings/partner-settings/': {
      id: '/(main)/settings/partner-settings/';
      path: '/partner-settings';
      fullPath: '/settings/partner-settings/';
      preLoaderRoute: typeof mainSettingsPartnerSettingsIndexRouteImport;
      parentRoute: typeof mainSettingsRouteRoute;
    };
    '/(main)/settings/product-price/': {
      id: '/(main)/settings/product-price/';
      path: '/product-price';
      fullPath: '/settings/product-price/';
      preLoaderRoute: typeof mainSettingsProductPriceIndexRouteImport;
      parentRoute: typeof mainSettingsRouteRoute;
    };
    '/(main)/suppliers/$supplierId/': {
      id: '/(main)/suppliers/$supplierId/';
      path: '/';
      fullPath: '/suppliers/$supplierId/';
      preLoaderRoute: typeof mainSuppliersSupplierIdIndexRouteImport;
      parentRoute: typeof mainSuppliersSupplierIdRouteRoute;
    };
    '/(main)/support/faq/': {
      id: '/(main)/support/faq/';
      path: '/support/faq';
      fullPath: '/support/faq/';
      preLoaderRoute: typeof mainSupportFaqIndexRouteImport;
      parentRoute: typeof mainRouteRoute;
    };
    '/(custom)/external/call-offs/$callOffId/': {
      id: '/(custom)/external/call-offs/$callOffId/';
      path: '/call-offs/$callOffId';
      fullPath: '/external/call-offs/$callOffId/';
      preLoaderRoute: typeof customExternalCallOffsCallOffIdIndexRouteImport;
      parentRoute: typeof customExternalRouteRoute;
    };
    '/(custom)/external/data-exchange-activation/$requestId/': {
      id: '/(custom)/external/data-exchange-activation/$requestId/';
      path: '/data-exchange-activation/$requestId';
      fullPath: '/external/data-exchange-activation/$requestId/';
      preLoaderRoute: typeof customExternalDataExchangeActivationRequestIdIndexRouteImport;
      parentRoute: typeof customExternalRouteRoute;
    };
    '/(main)/deliveries/all/$deliveryId/': {
      id: '/(main)/deliveries/all/$deliveryId/';
      path: '/';
      fullPath: '/deliveries/all/$deliveryId/';
      preLoaderRoute: typeof mainDeliveriesAllDeliveryIdIndexRouteImport;
      parentRoute: typeof mainDeliveriesAllDeliveryIdRouteRoute;
    };
    '/(main)/deliveries/all/$deliveryId/data-quality': {
      id: '/(main)/deliveries/all/$deliveryId/data-quality';
      path: '/data-quality';
      fullPath: '/deliveries/all/$deliveryId/data-quality';
      preLoaderRoute: typeof mainDeliveriesAllDeliveryIdDataQualityRouteImport;
      parentRoute: typeof mainDeliveriesAllDeliveryIdRouteRoute;
    };
    '/(main)/deliveries/all/create-delivery-note/': {
      id: '/(main)/deliveries/all/create-delivery-note/';
      path: '/deliveries/all/create-delivery-note';
      fullPath: '/deliveries/all/create-delivery-note/';
      preLoaderRoute: typeof mainDeliveriesAllCreateDeliveryNoteIndexRouteImport;
      parentRoute: typeof mainRouteRoute;
    };
    '/(main)/deliveries/all/create-service-note/': {
      id: '/(main)/deliveries/all/create-service-note/';
      path: '/deliveries/all/create-service-note';
      fullPath: '/deliveries/all/create-service-note/';
      preLoaderRoute: typeof mainDeliveriesAllCreateServiceNoteIndexRouteImport;
      parentRoute: typeof mainRouteRoute;
    };
    '/(main)/deliveries/scans/$scanId/': {
      id: '/(main)/deliveries/scans/$scanId/';
      path: '/deliveries/scans/$scanId';
      fullPath: '/deliveries/scans/$scanId/';
      preLoaderRoute: typeof mainDeliveriesScansScanIdIndexRouteImport;
      parentRoute: typeof mainRouteRoute;
    };
    '/(main)/deliveries/scans/import/': {
      id: '/(main)/deliveries/scans/import/';
      path: '/deliveries/scans/import';
      fullPath: '/deliveries/scans/import/';
      preLoaderRoute: typeof mainDeliveriesScansImportIndexRouteImport;
      parentRoute: typeof mainRouteRoute;
    };
    '/(main)/demand/call-offs/$callOffId/': {
      id: '/(main)/demand/call-offs/$callOffId/';
      path: '/call-offs/$callOffId';
      fullPath: '/demand/call-offs/$callOffId/';
      preLoaderRoute: typeof mainDemandCallOffsCallOffIdIndexRouteImport;
      parentRoute: typeof mainDemandRouteRoute;
    };
    '/(main)/demand/call-offs/calendar/': {
      id: '/(main)/demand/call-offs/calendar/';
      path: '/call-offs/calendar';
      fullPath: '/demand/call-offs/calendar/';
      preLoaderRoute: typeof mainDemandCallOffsCalendarIndexRouteImport;
      parentRoute: typeof mainDemandRouteRoute;
    };
    '/(main)/demand/call-offs/create/': {
      id: '/(main)/demand/call-offs/create/';
      path: '/call-offs/create';
      fullPath: '/demand/call-offs/create/';
      preLoaderRoute: typeof mainDemandCallOffsCreateIndexRouteImport;
      parentRoute: typeof mainDemandRouteRoute;
    };
    '/(main)/demand/contracts/$contractId/': {
      id: '/(main)/demand/contracts/$contractId/';
      path: '/contracts/$contractId';
      fullPath: '/demand/contracts/$contractId/';
      preLoaderRoute: typeof mainDemandContractsContractIdIndexRouteImport;
      parentRoute: typeof mainDemandRouteRoute;
    };
    '/(main)/demand/contracts/$contractId/edit': {
      id: '/(main)/demand/contracts/$contractId/edit';
      path: '/contracts/$contractId/edit';
      fullPath: '/demand/contracts/$contractId/edit';
      preLoaderRoute: typeof mainDemandContractsContractIdEditRouteRouteImport;
      parentRoute: typeof mainDemandRouteRoute;
    };
    '/(main)/demand/contracts/create/': {
      id: '/(main)/demand/contracts/create/';
      path: '/';
      fullPath: '/demand/contracts/create/';
      preLoaderRoute: typeof mainDemandContractsCreateIndexRouteImport;
      parentRoute: typeof mainDemandContractsCreateRouteRoute;
    };
    '/(main)/invoices/inbox/$emailId/': {
      id: '/(main)/invoices/inbox/$emailId/';
      path: '/invoices/inbox/$emailId';
      fullPath: '/invoices/inbox/$emailId/';
      preLoaderRoute: typeof mainInvoicesInboxEmailIdIndexRouteImport;
      parentRoute: typeof mainRouteRoute;
    };
    '/(main)/invoices/incoming/$invoiceId/': {
      id: '/(main)/invoices/incoming/$invoiceId/';
      path: '/';
      fullPath: '/invoices/incoming/$invoiceId/';
      preLoaderRoute: typeof mainInvoicesIncomingInvoiceIdIndexRouteImport;
      parentRoute: typeof mainInvoicesIncomingInvoiceIdRouteRoute;
    };
    '/(main)/invoices/v2/incoming/': {
      id: '/(main)/invoices/v2/incoming/';
      path: '/invoices/v2/incoming';
      fullPath: '/invoices/v2/incoming/';
      preLoaderRoute: typeof mainInvoicesV2IncomingIndexRouteImport;
      parentRoute: typeof mainRouteRoute;
    };
    '/(main)/settings/admin/custom-fields/': {
      id: '/(main)/settings/admin/custom-fields/';
      path: '/custom-fields';
      fullPath: '/settings/admin/custom-fields/';
      preLoaderRoute: typeof mainSettingsAdminCustomFieldsIndexRouteImport;
      parentRoute: typeof mainSettingsAdminRouteRoute;
    };
    '/(main)/settings/admin/data-subscription-logs/': {
      id: '/(main)/settings/admin/data-subscription-logs/';
      path: '/data-subscription-logs';
      fullPath: '/settings/admin/data-subscription-logs/';
      preLoaderRoute: typeof mainSettingsAdminDataSubscriptionLogsIndexRouteImport;
      parentRoute: typeof mainSettingsAdminRouteRoute;
    };
    '/(main)/settings/admin/data-subscriptions/': {
      id: '/(main)/settings/admin/data-subscriptions/';
      path: '/data-subscriptions';
      fullPath: '/settings/admin/data-subscriptions/';
      preLoaderRoute: typeof mainSettingsAdminDataSubscriptionsIndexRouteImport;
      parentRoute: typeof mainSettingsAdminRouteRoute;
    };
    '/(main)/settings/admin/data-sync/': {
      id: '/(main)/settings/admin/data-sync/';
      path: '/';
      fullPath: '/settings/admin/data-sync/';
      preLoaderRoute: typeof mainSettingsAdminDataSyncIndexRouteImport;
      parentRoute: typeof mainSettingsAdminDataSyncRouteRoute;
    };
    '/(main)/settings/admin/demo/': {
      id: '/(main)/settings/admin/demo/';
      path: '/demo';
      fullPath: '/settings/admin/demo/';
      preLoaderRoute: typeof mainSettingsAdminDemoIndexRouteImport;
      parentRoute: typeof mainSettingsAdminRouteRoute;
    };
    '/(main)/settings/admin/pdf-settings/': {
      id: '/(main)/settings/admin/pdf-settings/';
      path: '/pdf-settings';
      fullPath: '/settings/admin/pdf-settings/';
      preLoaderRoute: typeof mainSettingsAdminPdfSettingsIndexRouteImport;
      parentRoute: typeof mainSettingsAdminRouteRoute;
    };
    '/(main)/settings/admin/signature-fields/': {
      id: '/(main)/settings/admin/signature-fields/';
      path: '/signature-fields';
      fullPath: '/settings/admin/signature-fields/';
      preLoaderRoute: typeof mainSettingsAdminSignatureFieldsIndexRouteImport;
      parentRoute: typeof mainSettingsAdminRouteRoute;
    };
    '/(main)/settings/article-master/articles/': {
      id: '/(main)/settings/article-master/articles/';
      path: '/articles';
      fullPath: '/settings/article-master/articles/';
      preLoaderRoute: typeof mainSettingsArticleMasterArticlesIndexRouteImport;
      parentRoute: typeof mainSettingsArticleMasterRouteRoute;
    };
    '/(main)/settings/article-master/categories/': {
      id: '/(main)/settings/article-master/categories/';
      path: '/categories';
      fullPath: '/settings/article-master/categories/';
      preLoaderRoute: typeof mainSettingsArticleMasterCategoriesIndexRouteImport;
      parentRoute: typeof mainSettingsArticleMasterRouteRoute;
    };
    '/(main)/settings/masterdata/companies/': {
      id: '/(main)/settings/masterdata/companies/';
      path: '/masterdata/companies';
      fullPath: '/settings/masterdata/companies/';
      preLoaderRoute: typeof mainSettingsMasterdataCompaniesIndexRouteImport;
      parentRoute: typeof mainSettingsRouteRoute;
    };
    '/(main)/settings/masterdata/cost-centers/': {
      id: '/(main)/settings/masterdata/cost-centers/';
      path: '/masterdata/cost-centers';
      fullPath: '/settings/masterdata/cost-centers/';
      preLoaderRoute: typeof mainSettingsMasterdataCostCentersIndexRouteImport;
      parentRoute: typeof mainSettingsRouteRoute;
    };
    '/(main)/settings/masterdata/ledger-accounts/': {
      id: '/(main)/settings/masterdata/ledger-accounts/';
      path: '/masterdata/ledger-accounts';
      fullPath: '/settings/masterdata/ledger-accounts/';
      preLoaderRoute: typeof mainSettingsMasterdataLedgerAccountsIndexRouteImport;
      parentRoute: typeof mainSettingsRouteRoute;
    };
    '/(main)/settings/masterdata/org-groups/': {
      id: '/(main)/settings/masterdata/org-groups/';
      path: '/masterdata/org-groups';
      fullPath: '/settings/masterdata/org-groups/';
      preLoaderRoute: typeof mainSettingsMasterdataOrgGroupsIndexRouteImport;
      parentRoute: typeof mainSettingsRouteRoute;
    };
    '/(main)/settings/masterdata/roles/': {
      id: '/(main)/settings/masterdata/roles/';
      path: '/masterdata/roles';
      fullPath: '/settings/masterdata/roles/';
      preLoaderRoute: typeof mainSettingsMasterdataRolesIndexRouteImport;
      parentRoute: typeof mainSettingsRouteRoute;
    };
    '/(main)/settings/masterdata/sites/': {
      id: '/(main)/settings/masterdata/sites/';
      path: '/masterdata/sites';
      fullPath: '/settings/masterdata/sites/';
      preLoaderRoute: typeof mainSettingsMasterdataSitesIndexRouteImport;
      parentRoute: typeof mainSettingsRouteRoute;
    };
    '/(main)/settings/masterdata/tax-codes/': {
      id: '/(main)/settings/masterdata/tax-codes/';
      path: '/masterdata/tax-codes';
      fullPath: '/settings/masterdata/tax-codes/';
      preLoaderRoute: typeof mainSettingsMasterdataTaxCodesIndexRouteImport;
      parentRoute: typeof mainSettingsRouteRoute;
    };
    '/(main)/settings/masterdata/user-groups/': {
      id: '/(main)/settings/masterdata/user-groups/';
      path: '/masterdata/user-groups';
      fullPath: '/settings/masterdata/user-groups/';
      preLoaderRoute: typeof mainSettingsMasterdataUserGroupsIndexRouteImport;
      parentRoute: typeof mainSettingsRouteRoute;
    };
    '/(main)/settings/masterdata/users/': {
      id: '/(main)/settings/masterdata/users/';
      path: '/masterdata/users';
      fullPath: '/settings/masterdata/users/';
      preLoaderRoute: typeof mainSettingsMasterdataUsersIndexRouteImport;
      parentRoute: typeof mainSettingsRouteRoute;
    };
    '/(main)/settings/masterdata/vehicles/': {
      id: '/(main)/settings/masterdata/vehicles/';
      path: '/masterdata/vehicles';
      fullPath: '/settings/masterdata/vehicles/';
      preLoaderRoute: typeof mainSettingsMasterdataVehiclesIndexRouteImport;
      parentRoute: typeof mainSettingsRouteRoute;
    };
    '/(main)/settings/partner-settings/import/': {
      id: '/(main)/settings/partner-settings/import/';
      path: '/partner-settings/import';
      fullPath: '/settings/partner-settings/import/';
      preLoaderRoute: typeof mainSettingsPartnerSettingsImportIndexRouteImport;
      parentRoute: typeof mainSettingsRouteRoute;
    };
    '/(main)/suppliers/$supplierId/edit/': {
      id: '/(main)/suppliers/$supplierId/edit/';
      path: '/edit';
      fullPath: '/suppliers/$supplierId/edit/';
      preLoaderRoute: typeof mainSuppliersSupplierIdEditIndexRouteImport;
      parentRoute: typeof mainSuppliersSupplierIdRouteRoute;
    };
    '/(main)/demand/call-offs/$callOffId/edit/': {
      id: '/(main)/demand/call-offs/$callOffId/edit/';
      path: '/call-offs/$callOffId/edit';
      fullPath: '/demand/call-offs/$callOffId/edit/';
      preLoaderRoute: typeof mainDemandCallOffsCallOffIdEditIndexRouteImport;
      parentRoute: typeof mainDemandRouteRoute;
    };
    '/(main)/demand/contracts/$contractId/edit/': {
      id: '/(main)/demand/contracts/$contractId/edit/';
      path: '/';
      fullPath: '/demand/contracts/$contractId/edit/';
      preLoaderRoute: typeof mainDemandContractsContractIdEditIndexRouteImport;
      parentRoute: typeof mainDemandContractsContractIdEditRouteRoute;
    };
    '/(main)/invoices/v2/incoming/$invoiceId/': {
      id: '/(main)/invoices/v2/incoming/$invoiceId/';
      path: '/invoices/v2/incoming/$invoiceId';
      fullPath: '/invoices/v2/incoming/$invoiceId/';
      preLoaderRoute: typeof mainInvoicesV2IncomingInvoiceIdIndexRouteImport;
      parentRoute: typeof mainRouteRoute;
    };
    '/(main)/invoices/v2/incoming/import/': {
      id: '/(main)/invoices/v2/incoming/import/';
      path: '/invoices/v2/incoming/import';
      fullPath: '/invoices/v2/incoming/import/';
      preLoaderRoute: typeof mainInvoicesV2IncomingImportIndexRouteImport;
      parentRoute: typeof mainRouteRoute;
    };
    '/(main)/settings/admin/data-subscription-logs/$logId/': {
      id: '/(main)/settings/admin/data-subscription-logs/$logId/';
      path: '/data-subscription-logs/$logId';
      fullPath: '/settings/admin/data-subscription-logs/$logId/';
      preLoaderRoute: typeof mainSettingsAdminDataSubscriptionLogsLogIdIndexRouteImport;
      parentRoute: typeof mainSettingsAdminRouteRoute;
    };
    '/(main)/settings/admin/data-sync/logs/': {
      id: '/(main)/settings/admin/data-sync/logs/';
      path: '/logs';
      fullPath: '/settings/admin/data-sync/logs/';
      preLoaderRoute: typeof mainSettingsAdminDataSyncLogsIndexRouteImport;
      parentRoute: typeof mainSettingsAdminDataSyncRouteRoute;
    };
    '/(main)/demand/contracts/$contractId/items/$itemId/': {
      id: '/(main)/demand/contracts/$contractId/items/$itemId/';
      path: '/contracts/$contractId/items/$itemId';
      fullPath: '/demand/contracts/$contractId/items/$itemId/';
      preLoaderRoute: typeof mainDemandContractsContractIdItemsItemIdIndexRouteImport;
      parentRoute: typeof mainDemandRouteRoute;
    };
    '/(main)/demand/contracts/create/items/$itemId/': {
      id: '/(main)/demand/contracts/create/items/$itemId/';
      path: '/items/$itemId';
      fullPath: '/demand/contracts/create/items/$itemId/';
      preLoaderRoute: typeof mainDemandContractsCreateItemsItemIdIndexRouteImport;
      parentRoute: typeof mainDemandContractsCreateRouteRoute;
    };
    '/(main)/settings/admin/data-sync/$jobId/$taskId_/': {
      id: '/(main)/settings/admin/data-sync/$jobId/$taskId_/';
      path: '/$jobId/$taskId';
      fullPath: '/settings/admin/data-sync/$jobId/$taskId/';
      preLoaderRoute: typeof mainSettingsAdminDataSyncJobIdTaskIdIndexRouteImport;
      parentRoute: typeof mainSettingsAdminDataSyncRouteRoute;
    };
    '/(main)/settings/admin/data-sync/logs/$logId/': {
      id: '/(main)/settings/admin/data-sync/logs/$logId/';
      path: '/logs/$logId';
      fullPath: '/settings/admin/data-sync/logs/$logId/';
      preLoaderRoute: typeof mainSettingsAdminDataSyncLogsLogIdIndexRouteImport;
      parentRoute: typeof mainSettingsAdminDataSyncRouteRoute;
    };
    '/(main)/demand/contracts/$contractId/edit/items/$itemId/': {
      id: '/(main)/demand/contracts/$contractId/edit/items/$itemId/';
      path: '/items/$itemId';
      fullPath: '/demand/contracts/$contractId/edit/items/$itemId/';
      preLoaderRoute: typeof mainDemandContractsContractIdEditItemsItemIdIndexRouteImport;
      parentRoute: typeof mainDemandContractsContractIdEditRouteRoute;
    };
  }
}

interface customExternalRouteRouteChildren {
  customExternalUnsubscribeIndexRoute: typeof customExternalUnsubscribeIndexRoute;
  customExternalCallOffsCallOffIdIndexRoute: typeof customExternalCallOffsCallOffIdIndexRoute;
  customExternalDataExchangeActivationRequestIdIndexRoute: typeof customExternalDataExchangeActivationRequestIdIndexRoute;
}

const customExternalRouteRouteChildren: customExternalRouteRouteChildren = {
  customExternalUnsubscribeIndexRoute: customExternalUnsubscribeIndexRoute,
  customExternalCallOffsCallOffIdIndexRoute:
    customExternalCallOffsCallOffIdIndexRoute,
  customExternalDataExchangeActivationRequestIdIndexRoute:
    customExternalDataExchangeActivationRequestIdIndexRoute,
};

const customExternalRouteRouteWithChildren =
  customExternalRouteRoute._addFileChildren(customExternalRouteRouteChildren);

interface customRouteRouteChildren {
  customExternalRouteRoute: typeof customExternalRouteRouteWithChildren;
  customExternalSupplierRoute: typeof customExternalSupplierRoute;
  customPickupRoute: typeof customPickupRoute;
}

const customRouteRouteChildren: customRouteRouteChildren = {
  customExternalRouteRoute: customExternalRouteRouteWithChildren,
  customExternalSupplierRoute: customExternalSupplierRoute,
  customPickupRoute: customPickupRoute,
};

const customRouteRouteWithChildren = customRouteRoute._addFileChildren(
  customRouteRouteChildren,
);

interface mainDemandContractsCreateRouteRouteChildren {
  mainDemandContractsCreateIndexRoute: typeof mainDemandContractsCreateIndexRoute;
  mainDemandContractsCreateItemsItemIdIndexRoute: typeof mainDemandContractsCreateItemsItemIdIndexRoute;
}

const mainDemandContractsCreateRouteRouteChildren: mainDemandContractsCreateRouteRouteChildren =
  {
    mainDemandContractsCreateIndexRoute: mainDemandContractsCreateIndexRoute,
    mainDemandContractsCreateItemsItemIdIndexRoute:
      mainDemandContractsCreateItemsItemIdIndexRoute,
  };

const mainDemandContractsCreateRouteRouteWithChildren =
  mainDemandContractsCreateRouteRoute._addFileChildren(
    mainDemandContractsCreateRouteRouteChildren,
  );

interface mainDemandContractsContractIdEditRouteRouteChildren {
  mainDemandContractsContractIdEditIndexRoute: typeof mainDemandContractsContractIdEditIndexRoute;
  mainDemandContractsContractIdEditItemsItemIdIndexRoute: typeof mainDemandContractsContractIdEditItemsItemIdIndexRoute;
}

const mainDemandContractsContractIdEditRouteRouteChildren: mainDemandContractsContractIdEditRouteRouteChildren =
  {
    mainDemandContractsContractIdEditIndexRoute:
      mainDemandContractsContractIdEditIndexRoute,
    mainDemandContractsContractIdEditItemsItemIdIndexRoute:
      mainDemandContractsContractIdEditItemsItemIdIndexRoute,
  };

const mainDemandContractsContractIdEditRouteRouteWithChildren =
  mainDemandContractsContractIdEditRouteRoute._addFileChildren(
    mainDemandContractsContractIdEditRouteRouteChildren,
  );

interface mainDemandRouteRouteChildren {
  mainDemandContractsCreateRouteRoute: typeof mainDemandContractsCreateRouteRouteWithChildren;
  mainDemandCallOffsIndexRoute: typeof mainDemandCallOffsIndexRoute;
  mainDemandContractsIndexRoute: typeof mainDemandContractsIndexRoute;
  mainDemandContractsContractIdEditRouteRoute: typeof mainDemandContractsContractIdEditRouteRouteWithChildren;
  mainDemandCallOffsCallOffIdIndexRoute: typeof mainDemandCallOffsCallOffIdIndexRoute;
  mainDemandCallOffsCalendarIndexRoute: typeof mainDemandCallOffsCalendarIndexRoute;
  mainDemandCallOffsCreateIndexRoute: typeof mainDemandCallOffsCreateIndexRoute;
  mainDemandContractsContractIdIndexRoute: typeof mainDemandContractsContractIdIndexRoute;
  mainDemandCallOffsCallOffIdEditIndexRoute: typeof mainDemandCallOffsCallOffIdEditIndexRoute;
  mainDemandContractsContractIdItemsItemIdIndexRoute: typeof mainDemandContractsContractIdItemsItemIdIndexRoute;
}

const mainDemandRouteRouteChildren: mainDemandRouteRouteChildren = {
  mainDemandContractsCreateRouteRoute:
    mainDemandContractsCreateRouteRouteWithChildren,
  mainDemandCallOffsIndexRoute: mainDemandCallOffsIndexRoute,
  mainDemandContractsIndexRoute: mainDemandContractsIndexRoute,
  mainDemandContractsContractIdEditRouteRoute:
    mainDemandContractsContractIdEditRouteRouteWithChildren,
  mainDemandCallOffsCallOffIdIndexRoute: mainDemandCallOffsCallOffIdIndexRoute,
  mainDemandCallOffsCalendarIndexRoute: mainDemandCallOffsCalendarIndexRoute,
  mainDemandCallOffsCreateIndexRoute: mainDemandCallOffsCreateIndexRoute,
  mainDemandContractsContractIdIndexRoute:
    mainDemandContractsContractIdIndexRoute,
  mainDemandCallOffsCallOffIdEditIndexRoute:
    mainDemandCallOffsCallOffIdEditIndexRoute,
  mainDemandContractsContractIdItemsItemIdIndexRoute:
    mainDemandContractsContractIdItemsItemIdIndexRoute,
};

const mainDemandRouteRouteWithChildren = mainDemandRouteRoute._addFileChildren(
  mainDemandRouteRouteChildren,
);

interface mainSettingsAdminDataSyncRouteRouteChildren {
  mainSettingsAdminDataSyncIndexRoute: typeof mainSettingsAdminDataSyncIndexRoute;
  mainSettingsAdminDataSyncLogsIndexRoute: typeof mainSettingsAdminDataSyncLogsIndexRoute;
  mainSettingsAdminDataSyncJobIdTaskIdIndexRoute: typeof mainSettingsAdminDataSyncJobIdTaskIdIndexRoute;
  mainSettingsAdminDataSyncLogsLogIdIndexRoute: typeof mainSettingsAdminDataSyncLogsLogIdIndexRoute;
}

const mainSettingsAdminDataSyncRouteRouteChildren: mainSettingsAdminDataSyncRouteRouteChildren =
  {
    mainSettingsAdminDataSyncIndexRoute: mainSettingsAdminDataSyncIndexRoute,
    mainSettingsAdminDataSyncLogsIndexRoute:
      mainSettingsAdminDataSyncLogsIndexRoute,
    mainSettingsAdminDataSyncJobIdTaskIdIndexRoute:
      mainSettingsAdminDataSyncJobIdTaskIdIndexRoute,
    mainSettingsAdminDataSyncLogsLogIdIndexRoute:
      mainSettingsAdminDataSyncLogsLogIdIndexRoute,
  };

const mainSettingsAdminDataSyncRouteRouteWithChildren =
  mainSettingsAdminDataSyncRouteRoute._addFileChildren(
    mainSettingsAdminDataSyncRouteRouteChildren,
  );

interface mainSettingsAdminRouteRouteChildren {
  mainSettingsAdminDataSyncRouteRoute: typeof mainSettingsAdminDataSyncRouteRouteWithChildren;
  mainSettingsAdminCustomFieldsIndexRoute: typeof mainSettingsAdminCustomFieldsIndexRoute;
  mainSettingsAdminDataSubscriptionLogsIndexRoute: typeof mainSettingsAdminDataSubscriptionLogsIndexRoute;
  mainSettingsAdminDataSubscriptionsIndexRoute: typeof mainSettingsAdminDataSubscriptionsIndexRoute;
  mainSettingsAdminDemoIndexRoute: typeof mainSettingsAdminDemoIndexRoute;
  mainSettingsAdminPdfSettingsIndexRoute: typeof mainSettingsAdminPdfSettingsIndexRoute;
  mainSettingsAdminSignatureFieldsIndexRoute: typeof mainSettingsAdminSignatureFieldsIndexRoute;
  mainSettingsAdminDataSubscriptionLogsLogIdIndexRoute: typeof mainSettingsAdminDataSubscriptionLogsLogIdIndexRoute;
}

const mainSettingsAdminRouteRouteChildren: mainSettingsAdminRouteRouteChildren =
  {
    mainSettingsAdminDataSyncRouteRoute:
      mainSettingsAdminDataSyncRouteRouteWithChildren,
    mainSettingsAdminCustomFieldsIndexRoute:
      mainSettingsAdminCustomFieldsIndexRoute,
    mainSettingsAdminDataSubscriptionLogsIndexRoute:
      mainSettingsAdminDataSubscriptionLogsIndexRoute,
    mainSettingsAdminDataSubscriptionsIndexRoute:
      mainSettingsAdminDataSubscriptionsIndexRoute,
    mainSettingsAdminDemoIndexRoute: mainSettingsAdminDemoIndexRoute,
    mainSettingsAdminPdfSettingsIndexRoute:
      mainSettingsAdminPdfSettingsIndexRoute,
    mainSettingsAdminSignatureFieldsIndexRoute:
      mainSettingsAdminSignatureFieldsIndexRoute,
    mainSettingsAdminDataSubscriptionLogsLogIdIndexRoute:
      mainSettingsAdminDataSubscriptionLogsLogIdIndexRoute,
  };

const mainSettingsAdminRouteRouteWithChildren =
  mainSettingsAdminRouteRoute._addFileChildren(
    mainSettingsAdminRouteRouteChildren,
  );

interface mainSettingsArticleMasterRouteRouteChildren {
  mainSettingsArticleMasterArticlesIndexRoute: typeof mainSettingsArticleMasterArticlesIndexRoute;
  mainSettingsArticleMasterCategoriesIndexRoute: typeof mainSettingsArticleMasterCategoriesIndexRoute;
}

const mainSettingsArticleMasterRouteRouteChildren: mainSettingsArticleMasterRouteRouteChildren =
  {
    mainSettingsArticleMasterArticlesIndexRoute:
      mainSettingsArticleMasterArticlesIndexRoute,
    mainSettingsArticleMasterCategoriesIndexRoute:
      mainSettingsArticleMasterCategoriesIndexRoute,
  };

const mainSettingsArticleMasterRouteRouteWithChildren =
  mainSettingsArticleMasterRouteRoute._addFileChildren(
    mainSettingsArticleMasterRouteRouteChildren,
  );

interface mainSettingsRouteRouteChildren {
  mainSettingsAdminRouteRoute: typeof mainSettingsAdminRouteRouteWithChildren;
  mainSettingsArticleMasterRouteRoute: typeof mainSettingsArticleMasterRouteRouteWithChildren;
  mainSettingsDataProtectionIndexRoute: typeof mainSettingsDataProtectionIndexRoute;
  mainSettingsIgnoredArticlesIndexRoute: typeof mainSettingsIgnoredArticlesIndexRoute;
  mainSettingsImprintIndexRoute: typeof mainSettingsImprintIndexRoute;
  mainSettingsInvoiceCheckIndexRoute: typeof mainSettingsInvoiceCheckIndexRoute;
  mainSettingsMasterdataIndexRoute: typeof mainSettingsMasterdataIndexRoute;
  mainSettingsPartnerSettingsIndexRoute: typeof mainSettingsPartnerSettingsIndexRoute;
  mainSettingsProductPriceIndexRoute: typeof mainSettingsProductPriceIndexRoute;
  mainSettingsMasterdataCompaniesIndexRoute: typeof mainSettingsMasterdataCompaniesIndexRoute;
  mainSettingsMasterdataCostCentersIndexRoute: typeof mainSettingsMasterdataCostCentersIndexRoute;
  mainSettingsMasterdataLedgerAccountsIndexRoute: typeof mainSettingsMasterdataLedgerAccountsIndexRoute;
  mainSettingsMasterdataOrgGroupsIndexRoute: typeof mainSettingsMasterdataOrgGroupsIndexRoute;
  mainSettingsMasterdataRolesIndexRoute: typeof mainSettingsMasterdataRolesIndexRoute;
  mainSettingsMasterdataSitesIndexRoute: typeof mainSettingsMasterdataSitesIndexRoute;
  mainSettingsMasterdataTaxCodesIndexRoute: typeof mainSettingsMasterdataTaxCodesIndexRoute;
  mainSettingsMasterdataUserGroupsIndexRoute: typeof mainSettingsMasterdataUserGroupsIndexRoute;
  mainSettingsMasterdataUsersIndexRoute: typeof mainSettingsMasterdataUsersIndexRoute;
  mainSettingsMasterdataVehiclesIndexRoute: typeof mainSettingsMasterdataVehiclesIndexRoute;
  mainSettingsPartnerSettingsImportIndexRoute: typeof mainSettingsPartnerSettingsImportIndexRoute;
}

const mainSettingsRouteRouteChildren: mainSettingsRouteRouteChildren = {
  mainSettingsAdminRouteRoute: mainSettingsAdminRouteRouteWithChildren,
  mainSettingsArticleMasterRouteRoute:
    mainSettingsArticleMasterRouteRouteWithChildren,
  mainSettingsDataProtectionIndexRoute: mainSettingsDataProtectionIndexRoute,
  mainSettingsIgnoredArticlesIndexRoute: mainSettingsIgnoredArticlesIndexRoute,
  mainSettingsImprintIndexRoute: mainSettingsImprintIndexRoute,
  mainSettingsInvoiceCheckIndexRoute: mainSettingsInvoiceCheckIndexRoute,
  mainSettingsMasterdataIndexRoute: mainSettingsMasterdataIndexRoute,
  mainSettingsPartnerSettingsIndexRoute: mainSettingsPartnerSettingsIndexRoute,
  mainSettingsProductPriceIndexRoute: mainSettingsProductPriceIndexRoute,
  mainSettingsMasterdataCompaniesIndexRoute:
    mainSettingsMasterdataCompaniesIndexRoute,
  mainSettingsMasterdataCostCentersIndexRoute:
    mainSettingsMasterdataCostCentersIndexRoute,
  mainSettingsMasterdataLedgerAccountsIndexRoute:
    mainSettingsMasterdataLedgerAccountsIndexRoute,
  mainSettingsMasterdataOrgGroupsIndexRoute:
    mainSettingsMasterdataOrgGroupsIndexRoute,
  mainSettingsMasterdataRolesIndexRoute: mainSettingsMasterdataRolesIndexRoute,
  mainSettingsMasterdataSitesIndexRoute: mainSettingsMasterdataSitesIndexRoute,
  mainSettingsMasterdataTaxCodesIndexRoute:
    mainSettingsMasterdataTaxCodesIndexRoute,
  mainSettingsMasterdataUserGroupsIndexRoute:
    mainSettingsMasterdataUserGroupsIndexRoute,
  mainSettingsMasterdataUsersIndexRoute: mainSettingsMasterdataUsersIndexRoute,
  mainSettingsMasterdataVehiclesIndexRoute:
    mainSettingsMasterdataVehiclesIndexRoute,
  mainSettingsPartnerSettingsImportIndexRoute:
    mainSettingsPartnerSettingsImportIndexRoute,
};

const mainSettingsRouteRouteWithChildren =
  mainSettingsRouteRoute._addFileChildren(mainSettingsRouteRouteChildren);

interface mainSuppliersSupplierIdRouteRouteChildren {
  mainSuppliersSupplierIdIndexRoute: typeof mainSuppliersSupplierIdIndexRoute;
  mainSuppliersSupplierIdEditIndexRoute: typeof mainSuppliersSupplierIdEditIndexRoute;
}

const mainSuppliersSupplierIdRouteRouteChildren: mainSuppliersSupplierIdRouteRouteChildren =
  {
    mainSuppliersSupplierIdIndexRoute: mainSuppliersSupplierIdIndexRoute,
    mainSuppliersSupplierIdEditIndexRoute:
      mainSuppliersSupplierIdEditIndexRoute,
  };

const mainSuppliersSupplierIdRouteRouteWithChildren =
  mainSuppliersSupplierIdRouteRoute._addFileChildren(
    mainSuppliersSupplierIdRouteRouteChildren,
  );

interface mainDeliveriesAllDeliveryIdRouteRouteChildren {
  mainDeliveriesAllDeliveryIdDataQualityRoute: typeof mainDeliveriesAllDeliveryIdDataQualityRoute;
  mainDeliveriesAllDeliveryIdIndexRoute: typeof mainDeliveriesAllDeliveryIdIndexRoute;
}

const mainDeliveriesAllDeliveryIdRouteRouteChildren: mainDeliveriesAllDeliveryIdRouteRouteChildren =
  {
    mainDeliveriesAllDeliveryIdDataQualityRoute:
      mainDeliveriesAllDeliveryIdDataQualityRoute,
    mainDeliveriesAllDeliveryIdIndexRoute:
      mainDeliveriesAllDeliveryIdIndexRoute,
  };

const mainDeliveriesAllDeliveryIdRouteRouteWithChildren =
  mainDeliveriesAllDeliveryIdRouteRoute._addFileChildren(
    mainDeliveriesAllDeliveryIdRouteRouteChildren,
  );

interface mainInvoicesIncomingInvoiceIdRouteRouteChildren {
  mainInvoicesIncomingInvoiceIdIndexRoute: typeof mainInvoicesIncomingInvoiceIdIndexRoute;
}

const mainInvoicesIncomingInvoiceIdRouteRouteChildren: mainInvoicesIncomingInvoiceIdRouteRouteChildren =
  {
    mainInvoicesIncomingInvoiceIdIndexRoute:
      mainInvoicesIncomingInvoiceIdIndexRoute,
  };

const mainInvoicesIncomingInvoiceIdRouteRouteWithChildren =
  mainInvoicesIncomingInvoiceIdRouteRoute._addFileChildren(
    mainInvoicesIncomingInvoiceIdRouteRouteChildren,
  );

interface mainRouteRouteChildren {
  mainDemandRouteRoute: typeof mainDemandRouteRouteWithChildren;
  mainSettingsRouteRoute: typeof mainSettingsRouteRouteWithChildren;
  mainIndexRoute: typeof mainIndexRoute;
  mainSuppliersSupplierIdRouteRoute: typeof mainSuppliersSupplierIdRouteRouteWithChildren;
  mainAccountIndexRoute: typeof mainAccountIndexRoute;
  mainAgentChatIndexRoute: typeof mainAgentChatIndexRoute;
  mainAnalyticsIndexRoute: typeof mainAnalyticsIndexRoute;
  mainLegalIndexRoute: typeof mainLegalIndexRoute;
  mainReleaseNotesIndexRoute: typeof mainReleaseNotesIndexRoute;
  mainSuppliersIndexRoute: typeof mainSuppliersIndexRoute;
  mainSupportIndexRoute: typeof mainSupportIndexRoute;
  mainDeliveriesAllDeliveryIdRouteRoute: typeof mainDeliveriesAllDeliveryIdRouteRouteWithChildren;
  mainInvoicesIncomingInvoiceIdRouteRoute: typeof mainInvoicesIncomingInvoiceIdRouteRouteWithChildren;
  mainAnalyticsDeliveriesIndexRoute: typeof mainAnalyticsDeliveriesIndexRoute;
  mainAnalyticsEsgIndexRoute: typeof mainAnalyticsEsgIndexRoute;
  mainAnalyticsUsageIndexRoute: typeof mainAnalyticsUsageIndexRoute;
  mainDeliveriesAllV2IndexRoute: typeof mainDeliveriesAllV2IndexRoute;
  mainDeliveriesAllIndexRoute: typeof mainDeliveriesAllIndexRoute;
  mainDeliveriesRecentChangesIndexRoute: typeof mainDeliveriesRecentChangesIndexRoute;
  mainDeliveriesScansIndexRoute: typeof mainDeliveriesScansIndexRoute;
  mainInvoicesInboxIndexRoute: typeof mainInvoicesInboxIndexRoute;
  mainInvoicesIncomingIndexRoute: typeof mainInvoicesIncomingIndexRoute;
  mainInvoicesOutgoingIndexRoute: typeof mainInvoicesOutgoingIndexRoute;
  mainInvoicesSettingsIndexRoute: typeof mainInvoicesSettingsIndexRoute;
  mainSupportFaqIndexRoute: typeof mainSupportFaqIndexRoute;
  mainDeliveriesAllCreateDeliveryNoteIndexRoute: typeof mainDeliveriesAllCreateDeliveryNoteIndexRoute;
  mainDeliveriesAllCreateServiceNoteIndexRoute: typeof mainDeliveriesAllCreateServiceNoteIndexRoute;
  mainDeliveriesScansScanIdIndexRoute: typeof mainDeliveriesScansScanIdIndexRoute;
  mainDeliveriesScansImportIndexRoute: typeof mainDeliveriesScansImportIndexRoute;
  mainInvoicesInboxEmailIdIndexRoute: typeof mainInvoicesInboxEmailIdIndexRoute;
  mainInvoicesV2IncomingIndexRoute: typeof mainInvoicesV2IncomingIndexRoute;
  mainInvoicesV2IncomingInvoiceIdIndexRoute: typeof mainInvoicesV2IncomingInvoiceIdIndexRoute;
  mainInvoicesV2IncomingImportIndexRoute: typeof mainInvoicesV2IncomingImportIndexRoute;
}

const mainRouteRouteChildren: mainRouteRouteChildren = {
  mainDemandRouteRoute: mainDemandRouteRouteWithChildren,
  mainSettingsRouteRoute: mainSettingsRouteRouteWithChildren,
  mainIndexRoute: mainIndexRoute,
  mainSuppliersSupplierIdRouteRoute:
    mainSuppliersSupplierIdRouteRouteWithChildren,
  mainAccountIndexRoute: mainAccountIndexRoute,
  mainAgentChatIndexRoute: mainAgentChatIndexRoute,
  mainAnalyticsIndexRoute: mainAnalyticsIndexRoute,
  mainLegalIndexRoute: mainLegalIndexRoute,
  mainReleaseNotesIndexRoute: mainReleaseNotesIndexRoute,
  mainSuppliersIndexRoute: mainSuppliersIndexRoute,
  mainSupportIndexRoute: mainSupportIndexRoute,
  mainDeliveriesAllDeliveryIdRouteRoute:
    mainDeliveriesAllDeliveryIdRouteRouteWithChildren,
  mainInvoicesIncomingInvoiceIdRouteRoute:
    mainInvoicesIncomingInvoiceIdRouteRouteWithChildren,
  mainAnalyticsDeliveriesIndexRoute: mainAnalyticsDeliveriesIndexRoute,
  mainAnalyticsEsgIndexRoute: mainAnalyticsEsgIndexRoute,
  mainAnalyticsUsageIndexRoute: mainAnalyticsUsageIndexRoute,
  mainDeliveriesAllV2IndexRoute: mainDeliveriesAllV2IndexRoute,
  mainDeliveriesAllIndexRoute: mainDeliveriesAllIndexRoute,
  mainDeliveriesRecentChangesIndexRoute: mainDeliveriesRecentChangesIndexRoute,
  mainDeliveriesScansIndexRoute: mainDeliveriesScansIndexRoute,
  mainInvoicesInboxIndexRoute: mainInvoicesInboxIndexRoute,
  mainInvoicesIncomingIndexRoute: mainInvoicesIncomingIndexRoute,
  mainInvoicesOutgoingIndexRoute: mainInvoicesOutgoingIndexRoute,
  mainInvoicesSettingsIndexRoute: mainInvoicesSettingsIndexRoute,
  mainSupportFaqIndexRoute: mainSupportFaqIndexRoute,
  mainDeliveriesAllCreateDeliveryNoteIndexRoute:
    mainDeliveriesAllCreateDeliveryNoteIndexRoute,
  mainDeliveriesAllCreateServiceNoteIndexRoute:
    mainDeliveriesAllCreateServiceNoteIndexRoute,
  mainDeliveriesScansScanIdIndexRoute: mainDeliveriesScansScanIdIndexRoute,
  mainDeliveriesScansImportIndexRoute: mainDeliveriesScansImportIndexRoute,
  mainInvoicesInboxEmailIdIndexRoute: mainInvoicesInboxEmailIdIndexRoute,
  mainInvoicesV2IncomingIndexRoute: mainInvoicesV2IncomingIndexRoute,
  mainInvoicesV2IncomingInvoiceIdIndexRoute:
    mainInvoicesV2IncomingInvoiceIdIndexRoute,
  mainInvoicesV2IncomingImportIndexRoute:
    mainInvoicesV2IncomingImportIndexRoute,
};

const mainRouteRouteWithChildren = mainRouteRoute._addFileChildren(
  mainRouteRouteChildren,
);

const rootRouteChildren: RootRouteChildren = {
  customRouteRoute: customRouteRouteWithChildren,
  mainRouteRoute: mainRouteRouteWithChildren,
  IdsRedirectRoute: IdsRedirectRoute,
  UnauthorizedRoute: UnauthorizedRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
